import React from 'react';

function MobileSvg(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 337.098 337.098"
            style={{
                transform: "translateZ(50px)"
            }}
        >
            <defs>
                <linearGradient
                    id="linear-gradient-1"
                    x1="123.059"
                    x2="110.771"
                    y1="112.77"
                    y2="281.442"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#5a1bb3"/>  {/*208 blue 265*/}
                    <stop offset="1" stopColor="#5b1a91"/>  {/*216 blue 273*/}
                </linearGradient>
                <linearGradient
                    id="linear-gradient-2"
                    x1="221.033"
                    x2="132.786"
                    y1="62.359"
                    y2="282.975"
                    xlinkHref="#linear-gradient-1"
                />
                <clipPath id="clip-path">
                    <path
                        fill="none"
                        d="M191.781 43.779a1.563 1.563 0 00-.648-1.427l11.807 6.859a1.56 1.56 0 01.648 1.427c-.258-.145-.597-.346-.849-.493-.132-.08-.308-.18-.44-.255-.93-.54-1.855-1.075-2.785-1.616-1.314-.767-2.634-1.531-3.948-2.295q-1.895-1.103-3.785-2.2 5.904 3.433 11.807 6.859a4.882 4.882 0 01-2.22 3.857l-11.806-6.862a4.906 4.906 0 002.219-3.854z"
                    />
                </clipPath>
                <clipPath id="clip-path-2">
                    <path
                        fill="none"
                        d="M191.133 42.352c.177.1.412.239.592.34q5.601 3.262 11.215 6.519a1.576 1.576 0 00-1.584.157l-11.81-6.862a1.57 1.57 0 011.587-.154z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-3">
                    <path
                        fill="none"
                        d="M139.827 75.584a1.586 1.586 0 001.593-.157l11.81 6.86a1.582 1.582 0 01-1.594.163c-3.543-2.062-8.267-4.804-11.81-6.866z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-4">
                    <path
                        fill="none"
                        d="M151.636 82.45q-5.903-3.433-11.81-6.866a1.564 1.564 0 01-.647-1.436 4.887 4.887 0 012.225-3.85l11.813 6.864a4.87 4.87 0 00-2.228 3.848 1.567 1.567 0 00.647 1.44z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-5">
                    <path
                        fill="none"
                        d="M212.729 173.578a3.712 3.712 0 011.553 2.842l2.056 1.194a3.738 3.738 0 00-1.553-2.845c-.616-.358-1.44-.833-2.056-1.19z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-6">
                    <path
                        fill="none"
                        d="M214.785 174.77l-2.056-1.192a2.157 2.157 0 00-.767-.27l2.056 1.194a2.213 2.213 0 01.767.267z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-7">
                    <path
                        fill="none"
                        d="M212.286 171.774l1.16.676.138.078c.035.022.091.053.126.075.044.025.094.057.135.079.167.091.33.186.493.286-.685-.396-1.367-.798-2.052-1.194z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-8">
                    <path
                        fill="none"
                        d="M211.962 173.308c.685.402 1.37.798 2.056 1.194a4.325 4.325 0 00.32-1.534l-.364-.214c-.176-.1-.349-.204-.528-.304-.387-.227-.774-.45-1.16-.676.685.396 1.367.798 2.052 1.194a1.616 1.616 0 00-.672-1.49l-2.056-1.195a1.621 1.621 0 01.676 1.49 4.26 4.26 0 01-.324 1.535z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-9">
                    <path
                        fill="none"
                        d="M210.038 176.803l-2.056-1.195a12.108 12.108 0 00-2.294 5.778l2.056 1.192a12.128 12.128 0 012.294-5.775z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-10">
                    <path
                        fill="none"
                        d="M213.666 171.478l-2.056-1.195a1.636 1.636 0 00-1.647.167l2.05 1.192a1.646 1.646 0 011.653-.164z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-11">
                    <path
                        fill="none"
                        d="M212.012 171.642l-2.05-1.192a5.077 5.077 0 00-2.31 3.999 1.955 1.955 0 00.33 1.16l2.056 1.194a1.965 1.965 0 01-.333-1.163 5.087 5.087 0 012.307-3.998z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-12">
                    <path
                        fill="none"
                        d="M169.52 233.97a3.725 3.725 0 011.555 2.848l2.05 1.194a3.719 3.719 0 00-1.55-2.848c-.616-.358-1.44-.833-2.056-1.194z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-13">
                    <path
                        fill="none"
                        d="M171.575 235.164l-2.056-1.194a2.133 2.133 0 00-.764-.268l2.053 1.192a2.177 2.177 0 01.767.27z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-14">
                    <path
                        fill="none"
                        d="M169.08 232.165c.383.227.773.453 1.156.68.04.018.094.053.138.075.035.019.092.053.129.075a1.172 1.172 0 00.135.076c.164.1.327.194.49.289a287.38 287.38 0 01-2.048-1.195z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-15">
                    <path
                        fill="none"
                        d="M168.755 233.702c.683.396 1.368.796 2.053 1.192a4.332 4.332 0 00.32-1.534c-.119-.07-.245-.138-.364-.214l-.528-.301c-.383-.227-.773-.453-1.156-.68.678.4 1.364.799 2.049 1.195a1.623 1.623 0 00-.673-1.49l-2.056-1.192a1.639 1.639 0 01.68 1.487 4.348 4.348 0 01-.325 1.537z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-16">
                    <path
                        fill="none"
                        d="M166.828 237.195L164.773 236a12.1 12.1 0 00-2.295 5.778l2.056 1.195a12.126 12.126 0 012.294-5.778z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-17">
                    <path
                        fill="none"
                        d="M170.456 231.87l-2.056-1.192a1.642 1.642 0 00-1.647.164l2.053 1.194a1.635 1.635 0 011.65-.166z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-18">
                    <path
                        fill="none"
                        d="M168.806 232.036l-2.053-1.194a5.062 5.062 0 00-2.307 3.998 1.93 1.93 0 00.327 1.16l2.055 1.195a1.956 1.956 0 01-.333-1.16 5.078 5.078 0 012.31-3.999z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-19">
                    <path
                        fill="none"
                        d="M212.729 94.464a3.716 3.716 0 011.553 2.848l2.056 1.188a3.732 3.732 0 00-1.553-2.842l-2.056-1.194z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-20">
                    <path
                        fill="none"
                        d="M214.785 95.658l-2.056-1.194a2.163 2.163 0 00-.767-.27l2.056 1.194a2.233 2.233 0 01.767.27z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-21">
                    <path
                        fill="none"
                        d="M212.286 92.66l1.16.678c.04.02.094.05.138.076.035.022.091.056.126.075l.135.079c.167.098.33.188.493.286-.685-.396-1.367-.795-2.052-1.195z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-22">
                    <path
                        fill="none"
                        d="M211.962 94.194c.685.402 1.37.798 2.056 1.194a4.324 4.324 0 00.32-1.534c-.119-.07-.245-.142-.364-.214l-.528-.302-1.16-.679c.685.4 1.367.799 2.052 1.195a1.62 1.62 0 00-.672-1.49l-2.056-1.191a1.612 1.612 0 01.676 1.486 4.25 4.25 0 01-.324 1.535z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-23">
                    <path
                        fill="none"
                        d="M210.038 97.686l-2.056-1.191a12.13 12.13 0 00-2.294 5.777l2.056 1.195a12.154 12.154 0 012.294-5.781z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-24">
                    <path
                        fill="none"
                        d="M213.666 92.364l-2.056-1.191a1.634 1.634 0 00-1.647.163l2.05 1.192a1.653 1.653 0 011.653-.164z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-25">
                    <path
                        fill="none"
                        d="M212.012 92.528l-2.05-1.192a5.076 5.076 0 00-2.31 3.998 1.95 1.95 0 00.33 1.16l2.056 1.192a1.936 1.936 0 01-.333-1.157 5.093 5.093 0 012.307-4.001z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-26">
                    <path
                        fill="none"
                        d="M169.52 154.859a3.707 3.707 0 011.555 2.845l2.05 1.19a3.725 3.725 0 00-1.55-2.844 726.46 726.46 0 00-2.056-1.191z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-27">
                    <path
                        fill="none"
                        d="M171.575 156.05l-2.056-1.191a2.197 2.197 0 00-.764-.27l2.053 1.194a2.239 2.239 0 01.767.267z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-28">
                    <path
                        fill="none"
                        d="M169.08 153.051c.383.226.773.453 1.156.68.04.024.094.05.138.075.035.025.092.056.129.078.041.022.091.054.135.073.164.1.327.194.49.289-.685-.396-1.37-.792-2.048-1.195z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-29">
                    <path
                        fill="none"
                        d="M168.755 154.588c.683.4 1.368.795 2.053 1.195a4.362 4.362 0 00.32-1.537c-.119-.07-.245-.139-.364-.214l-.528-.302-1.156-.679c.678.403 1.364.799 2.049 1.195a1.63 1.63 0 00-.673-1.49l-2.056-1.192a1.639 1.639 0 01.68 1.487 4.335 4.335 0 01-.325 1.537z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-30">
                    <path
                        fill="none"
                        d="M166.828 158.08l-2.055-1.194a12.097 12.097 0 00-2.295 5.778l2.056 1.194a12.138 12.138 0 012.294-5.777z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-31">
                    <path
                        fill="none"
                        d="M170.456 152.756l-2.056-1.192a1.635 1.635 0 00-1.647.167l2.053 1.192a1.65 1.65 0 011.65-.167z"
                        data-name="SVGID"
                    />
                </clipPath>
                <clipPath id="clip-path-32">
                    <path
                        fill="none"
                        d="M168.806 152.923l-2.053-1.192a5.06 5.06 0 00-2.307 3.998 1.927 1.927 0 00.327 1.157l2.055 1.195a1.956 1.956 0 01-.333-1.16 5.077 5.077 0 012.31-3.998z"
                        data-name="SVGID"
                    />
                </clipPath>
            </defs>
            <g data-name="Layer 2">
                <path
                    d="M224.74 261.706l-93.37 50.711a8.771 8.771 0 01-8.343.016l-102.493-55.15a8.771 8.771 0 01.134-15.518l94.43-48.73a8.771 8.771 0 018.094.025l101.434 53.17a8.771 8.771 0 01.114 15.476z"
                    opacity="0.1"
                />
                <path
                    fill="#bfd4db"
                    d="M123.091 295.094L111.281 288.232 222.967 223.75 234.777 230.612 123.091 295.094z"
                />
                <path
                    fill="#eedeff" /*196 cyan 270*/
                    d="M123.128 309.16l-.037-14.066-11.81-6.862.04 14.063c.007 2.886 1.025 4.914 2.67 5.87q5.907 3.432 11.81 6.865c-1.641-.96-2.663-2.987-2.673-5.87z"
                />
                <path
                    fill="#cba9eb"
                    d="M123.128 309.16l-.037-14.066 111.686-64.482.04 14.064c.017 5.816-4.067 12.885-9.128 15.812l-93.363 53.9c-5.054 2.92-9.179.585-9.198-5.227z"
                />
                <path
                    fill="url(#linear-gradient-1)"
                    d="M123.091 295.094L111.281 288.232 110.743 99.072 122.556 105.934 123.091 295.094z"
                />
                <path
                    fill="#35c2da"
                    d="M122.556 105.934L110.743 99.072 222.43 34.588 234.243 41.453 122.556 105.934z"
                />
                <path
                    fill="url(#linear-gradient-2)"
                    d="M234.243 41.453L234.777 230.612 123.091 295.094 122.556 105.934 234.243 41.453z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path)">
                    <path
                        fill="#b2c5cc"
                        d="M201.369 54.495l-11.807-6.862a3.748 3.748 0 00.742-.579l11.81 6.863a3.554 3.554 0 01-.745.578z"
                    />
                    <path
                        fill="#adc0c7"
                        d="M202.113 53.917l-11.81-6.863a3.72 3.72 0 00.243-.258l11.81 6.863a3.192 3.192 0 01-.243.258z"
                    />
                    <path
                        fill="#a9bbc2"
                        d="M202.356 53.659l-11.81-6.863c.066-.068.122-.144.185-.22l11.807 6.866c-.06.075-.12.148-.182.217z"
                    />
                    <path
                        fill="#a4b6bd"
                        d="M202.538 53.442l-11.807-6.865c.05-.066.095-.132.145-.202l11.81 6.866c-.048.069-.098.132-.148.201z"
                    />
                    <path
                        fill="#a0b1b8"
                        d="M202.686 53.24l-11.81-6.865c.044-.062.085-.125.126-.188l11.81 6.862c-.041.066-.085.129-.126.192z"
                    />
                    <path
                        fill="#9bacb3"
                        d="M202.811 53.049l-11.81-6.862c.041-.063.082-.126.117-.189l11.81 6.866a6.204 6.204 0 01-.117.185z"
                    />
                    <path
                        fill="#97a7ad"
                        d="M202.928 52.864l-11.81-6.866c.034-.063.072-.126.104-.185l11.81 6.862-.104.189z"
                    />
                    <path
                        fill="#93a2a8"
                        d="M203.032 52.675l-11.81-6.862c.03-.063.066-.13.097-.192l11.81 6.865c-.032.063-.063.126-.097.189z"
                    />
                    <path
                        fill="#8e9da3"
                        d="M203.13 52.486l-11.811-6.865c.028-.063.06-.126.088-.192l11.81 6.862c-.029.063-.057.13-.088.195z"
                    />
                    <path
                        fill="#8a999e"
                        d="M203.217 52.291l-11.81-6.862c.029-.066.054-.132.079-.198l11.813 6.86a3.6 3.6 0 01-.082.2z"
                    />
                    <path
                        fill="#859499"
                        d="M203.299 52.09l-11.813-6.859c.028-.069.053-.144.078-.213l11.81 6.865-.075.207z"
                    />
                    <path
                        fill="#818f94"
                        d="M203.374 51.883l-11.81-6.866c.025-.075.047-.15.073-.226l11.806 6.862c-.018.076-.044.151-.069.23z"
                    />
                    <path
                        fill="#7c8a8f"
                        d="M203.443 51.653l-11.806-6.862c.018-.085.044-.173.06-.258l11.81 6.863c-.02.084-.039.173-.064.257z"
                    />
                    <path
                        fill="#78858a"
                        d="M203.506 51.396l-11.81-6.863a2.919 2.919 0 00.054-.314l11.81 6.865a2.752 2.752 0 01-.054.312z"
                    />
                    <path
                        fill="#738085"
                        d="M203.56 51.084l-11.81-6.865a3.016 3.016 0 00.031-.44 1.563 1.563 0 00-.648-1.427l11.807 6.859a1.56 1.56 0 01.648 1.427 3.063 3.063 0 01-.028.446z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-2)">
                    <path
                        fill="#32b5ca"
                        d="M201.356 49.368l-11.81-6.862a2.367 2.367 0 01.311-.154l11.814 6.859a3.288 3.288 0 00-.315.157z"
                    />
                    <path
                        fill="#30b0c5"
                        d="M201.67 49.21l-11.813-6.858a2.196 2.196 0 01.265-.094l11.81 6.865a1.844 1.844 0 00-.261.088z"
                    />
                    <path
                        fill="#2facc0"
                        d="M201.931 49.123l-11.81-6.865a1.487 1.487 0 01.195-.041l11.813 6.862a1.981 1.981 0 00-.198.044z"
                    />
                    <path
                        fill="#2ea7bb"
                        d="M202.13 49.079l-11.814-6.862a1.557 1.557 0 01.167-.016l11.81 6.862c-.057.003-.11.01-.164.016z"
                    />
                    <path
                        fill="#2da3b6"
                        d="M202.293 49.063l-11.81-6.862h.148l11.806 6.865a.763.763 0 00-.144-.003z"
                    />
                    <path
                        fill="#2b9eb1"
                        d="M202.437 49.066l-11.806-6.865c.047.003.087.01.132.016l11.813 6.862a.978.978 0 00-.139-.013z"
                    />
                    <path
                        fill="#2a9aac"
                        d="M202.576 49.079l-11.813-6.862a1.185 1.185 0 01.125.028l11.813 6.865a.914.914 0 00-.125-.031z"
                    />
                    <path
                        fill="#2995a7"
                        d="M202.701 49.11l-11.813-6.865a.64.64 0 01.12.044l11.807 6.862a1.535 1.535 0 00-.114-.04z"
                    />
                    <path
                        fill="#2891a2"
                        d="M202.815 49.151l-11.807-6.862a.652.652 0 01.11.05l11.81 6.866a1.21 1.21 0 00-.113-.054z"
                    />
                    <path
                        fill="#268c9d"
                        d="M202.928 49.205l-11.81-6.866c.003.006.01.006.015.013l11.807 6.859c-.006 0-.006-.006-.012-.006z"
                    />
                </g>
                <path
                    fill="#bfd4db"
                    d="M153.23 82.286L141.42 75.427 189.562 47.633 201.369 54.495 153.23 82.286z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-3)">
                    <path
                        fill="#8a999e"
                        d="M151.636 82.45l-11.81-6.866c.007.003.007.007.013.007l11.807 6.865-.01-.006z"
                    />
                    <path
                        fill="#8e9da3"
                        d="M151.646 82.456l-11.807-6.865c.038.022.075.037.113.056l11.807 6.862c-.038-.015-.075-.034-.113-.053z"
                    />
                    <path
                        fill="#93a2a8"
                        d="M151.759 82.51l-11.807-6.863a.523.523 0 00.117.038l11.81 6.865a1.021 1.021 0 01-.12-.04z"
                    />
                    <path
                        fill="#97a7ad"
                        d="M151.878 82.55l-11.81-6.865a.864.864 0 00.123.031l11.813 6.865a1.177 1.177 0 01-.126-.03z"
                    />
                    <path
                        fill="#9bacb3"
                        d="M152.004 82.582l-11.813-6.866.138.02 11.807 6.858a1.743 1.743 0 01-.132-.012z"
                    />
                    <path
                        fill="#a0b1b8"
                        d="M152.136 82.594l-11.807-6.859h.145l11.81 6.86a.577.577 0 01-.148 0z"
                    />
                    <path
                        fill="#a4b6bd"
                        d="M152.284 82.594l-11.81-6.859.167-.019 11.81 6.866a1.515 1.515 0 01-.167.012z"
                    />
                    <path
                        fill="#a9bbc2"
                        d="M152.45 82.582l-11.81-6.866a1.447 1.447 0 00.198-.044l11.81 6.866c-.065.018-.132.03-.198.044z"
                    />
                    <path
                        fill="#adc0c7"
                        d="M152.648 82.538l-11.81-6.866a1.71 1.71 0 00.264-.088l11.81 6.86a2.075 2.075 0 01-.264.094z"
                    />
                    <path
                        fill="#b2c5cc"
                        d="M152.912 82.443l-11.81-6.859a2.951 2.951 0 00.318-.157l11.81 6.86a2.238 2.238 0 01-.318.156z"
                    />
                </g>
                <path
                    fill="#35c2da"
                    d="M153.217 77.162L141.404 70.297 189.546 42.506 201.356 49.368 153.217 77.162z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-4)">
                    <path
                        fill="#207684"
                        d="M151.636 82.45l-11.81-6.866a1.564 1.564 0 01-.647-1.436 3.39 3.39 0 01.025-.437l11.813 6.862a2.99 2.99 0 00-.028.437 1.567 1.567 0 00.647 1.44z"
                    />
                    <path
                        fill="#217a89"
                        d="M151.017 80.573l-11.813-6.862a2.491 2.491 0 01.057-.308l11.806 6.862a3.318 3.318 0 00-.05.308z"
                    />
                    <path
                        fill="#237f8e"
                        d="M151.067 80.265l-11.806-6.862c.018-.088.037-.17.062-.258l11.807 6.865c-.022.085-.044.17-.063.255z"
                    />
                    <path
                        fill="#248393"
                        d="M151.13 80.01l-11.807-6.865a2.7 2.7 0 01.07-.223l11.806 6.862c-.025.075-.047.151-.069.226z"
                    />
                    <path
                        fill="#258898"
                        d="M151.2 79.784l-11.807-6.862a1.684 1.684 0 01.075-.21l11.807 6.864-.076.208z"
                    />
                    <path
                        fill="#268c9d"
                        d="M151.275 79.576l-11.807-6.865c.025-.07.05-.132.078-.201l11.81 6.865a2.152 2.152 0 00-.081.201z"
                    />
                    <path
                        fill="#2891a2"
                        d="M151.357 79.375l-11.81-6.865c.028-.063.06-.126.088-.192l11.81 6.866c-.032.06-.06.125-.088.191z"
                    />
                    <path
                        fill="#2995a7"
                        d="M151.444 79.184l-11.81-6.866c.032-.063.067-.122.098-.185l11.807 6.859-.095.192z"
                    />
                    <path
                        fill="#2a9aac"
                        d="M151.539 78.992l-11.807-6.86c.031-.062.07-.125.1-.188l11.814 6.866c-.038.06-.072.122-.107.182z"
                    />
                    <path
                        fill="#2b9eb1"
                        d="M151.646 78.81l-11.813-6.866c.037-.063.075-.125.119-.188l11.807 6.865c-.038.06-.079.126-.113.189z"
                    />
                    <path
                        fill="#2da3b6"
                        d="M151.759 78.621l-11.807-6.865c.038-.063.082-.126.126-.189l11.807 6.859c-.041.063-.082.129-.126.195z"
                    />
                    <path
                        fill="#2ea7bb"
                        d="M151.885 78.426l-11.807-6.859c.05-.07.094-.138.148-.201l11.81 6.862c-.05.063-.101.129-.151.198z"
                    />
                    <path
                        fill="#2facc0"
                        d="M152.036 78.225l-11.81-6.859c.06-.076.116-.15.179-.22l11.813 6.862c-.063.069-.123.141-.182.22z"
                    />
                    <path
                        fill="#30b0c5"
                        d="M152.218 78.008l-11.813-6.862q.122-.142.245-.264l11.813 6.865a3.23 3.23 0 00-.245.26z"
                    />
                    <path
                        fill="#32b5ca"
                        d="M152.463 77.747l-11.813-6.865a4.066 4.066 0 01.754-.585l11.813 6.865a3.548 3.548 0 00-.754.585z"
                    />
                </g>
                <path
                    fill="#6d2fc4"  /*189 cyan 265*/
                    d="M201.356 49.368c1.232-.71 2.229-.141 2.232 1.27a4.882 4.882 0 01-2.22 3.857L153.23 82.286c-1.242.717-2.241.151-2.241-1.276a4.87 4.87 0 012.228-3.848z"
                />
                <path
                    fill="#cba9eb"
                    d="M225.032 28.03c5.058-2.923 9.17-.569 9.186 5.244l.025 8.179-111.687 64.478-.025-8.173c-.016-5.815 4.08-12.907 9.141-15.827zM201.37 54.496a4.882 4.882 0 002.22-3.857c-.004-1.411-1-1.98-2.233-1.27l-48.139 27.794a4.87 4.87 0 00-2.228 3.848c0 1.427 1 1.993 2.24 1.276l48.14-27.791z"
                />
                <path
                    fill="#eedeff"
                    d="M226.535 27.314c.22-.085.437-.16.654-.227.132-.037.264-.078.396-.11a8.161 8.161 0 011.141-.182c.198-.016.396-.016.588-.013.044.003.088 0 .132.003a5.253 5.253 0 01.675.085c.057.01.11.026.167.038a4.533 4.533 0 01.497.142c.05.018.107.037.157.056a4.542 4.542 0 01.6.286l-11.81-6.862a1.033 1.033 0 01-.05-.031 4.735 4.735 0 00-.459-.224 2.554 2.554 0 01-.088-.031 1.58 1.58 0 00-.16-.053 2.206 2.206 0 00-.236-.086c-.085-.021-.173-.04-.26-.059-.054-.013-.11-.032-.167-.041a.887.887 0 00-.088-.016 3.94 3.94 0 00-.55-.069h-.18a3.88 3.88 0 00-.427-.003c-.05.003-.1.01-.15.016a4.7 4.7 0 00-.274.028c-.088.01-.173.01-.261.022-.076.013-.154.038-.233.05-.12.026-.239.05-.365.08-.069.015-.135.024-.207.043-.066.019-.138.05-.204.072a6.643 6.643 0 00-.648.227c-.075.025-.148.044-.223.075-.04.019-.085.044-.126.063a10.905 10.905 0 00-1.154.572L119.86 75.07a13.583 13.583 0 00-1.427.965c-.079.06-.157.116-.232.176a16.724 16.724 0 00-1.296 1.135c-.031.034-.069.06-.103.094-.067.063-.13.138-.192.201-.208.214-.418.437-.623.663-.059.066-.125.132-.188.202l-.151.185c-.122.145-.245.295-.365.443-.075.094-.154.183-.226.28-.063.082-.122.164-.182.245-.082.113-.17.224-.252.34-.056.082-.12.157-.176.242-.1.141-.191.283-.289.424-.056.088-.113.17-.17.258l-.075.113c-.164.252-.32.51-.475.773a.391.391 0 01-.034.063c-.025.04-.044.082-.07.126-.11.195-.22.39-.327.585-.047.088-.087.182-.135.27-.047.088-.09.176-.135.26-.04.086-.085.168-.125.249-.101.214-.195.422-.29.635-.019.044-.044.088-.063.132a.126.126 0 01-.012.032c-.117.273-.226.547-.334.823a1.548 1.548 0 00-.056.151c-.038.1-.072.201-.107.305l-.15.409c-.032.103-.064.21-.095.317-.038.126-.082.255-.116.384-.022.075-.05.154-.073.232-.037.138-.069.277-.1.415-.041.16-.085.32-.12.478l-.037.16c-.025.11-.038.22-.057.33-.05.246-.091.49-.126.736-.012.069-.028.135-.037.204-.007.066-.007.126-.01.189a12.74 12.74 0 00-.104 1.603l.02 8.176 11.812 6.859-.025-8.173a14.778 14.778 0 01.104-1.603c.015-.132.028-.261.047-.393.038-.242.082-.487.126-.733.034-.163.063-.33.097-.493.035-.16.079-.32.117-.48.056-.215.113-.428.172-.64a20.994 20.994 0 01.362-1.116c.038-.1.07-.2.107-.3.129-.34.264-.674.408-1.007.02-.05.044-.1.07-.15.125-.284.257-.563.392-.843.054-.1.104-.201.158-.302.135-.264.273-.521.418-.779.04-.07.075-.139.116-.205.182-.314.374-.625.57-.927.062-.094.118-.182.181-.27.145-.22.296-.437.45-.648.085-.12.17-.232.258-.349a20.053 20.053 0 01.77-.962c.113-.135.232-.267.352-.399.195-.22.402-.44.607-.647l.304-.309q.628-.603 1.286-1.13l.242-.18a13.248 13.248 0 011.427-.962l93.36-53.9a10.014 10.014 0 011.151-.573c.116-.05.235-.1.352-.144z"
                />
                <g opacity="0.1">
                    <path
                        d="M237.801 191.448a.031.031 0 01.013.004q-.986-.571-1.968-1.145a4.394 4.394 0 00-.267-.122c-.072-.022-.148-.041-.22-.06h-.01a3.674 3.674 0 00-.188-.032 1.669 1.669 0 00-.174-.006 1.346 1.346 0 00-.153.006.142.142 0 00-.038.004h-.012c-.032.006-.064.006-.095.01-.05.009-.1.012-.145.024a.817.817 0 00-.132.032.89.89 0 00-.138.034c-.035.013-.069.026-.097.035-.007 0-.01.003-.016.003a.07.07 0 01-.025.003c-.041.019-.085.035-.132.053-.041.016-.088.038-.132.054-.04.025-.088.044-.132.07-.044.018-.091.043-.139.065a1.055 1.055 0 01-.103.06l-48.589 28.052a.219.219 0 00-.03.019c-.051.028-.095.056-.146.088-.043.031-.09.06-.138.094l-.145.1c-.05.038-.094.073-.144.114-.019.012-.038.028-.057.04a.14.14 0 01-.012.016.764.764 0 00-.076.063c-.05.041-.1.082-.15.126-.05.044-.095.094-.145.138-.044.044-.094.088-.139.139l-.094.094a.073.073 0 01-.015.019c-.01.009-.016.019-.026.028-.04.047-.088.091-.128.141-.044.051-.082.098-.126.148-.044.05-.088.104-.13.16a1.557 1.557 0 00-.134.183l-.013.006c-.07.097-.141.198-.207.299-.088.129-.17.267-.252.402l-.019.028a.066.066 0 00-.012.032 3.058 3.058 0 00-.126.22c-.032.066-.069.132-.1.195a1.465 1.465 0 00-.082.176c-.025.05-.054.107-.076.157a.061.061 0 01-.01.022l-.002.01c-.019.043-.038.081-.054.125a1.501 1.501 0 00-.066.16c-.021.054-.04.11-.06.16-.021.06-.037.114-.06.167-.018.06-.037.114-.056.173a.074.074 0 01-.003.025l-.003.01c-.012.047-.028.091-.044.138-.016.06-.025.116-.044.173-.016.06-.025.116-.038.176l-.038.17-.028.17c-.009.05-.016.107-.022.163a3.91 3.91 0 00-.031.32 2.572 2.572 0 00-.007.164 1.116 1.116 0 00-.006.145l.032 10.945a.218.218 0 00.003.044.32.32 0 00.003.057l.01.081a1.141 1.141 0 00.015.114l.006.075.085 13.391 1.971 1.144 10.801-16.276 40.978-23.66a7.224 7.224 0 003.285-5.694l-.028-10.939a2.314 2.314 0 00-.975-2.122zm-.474-.179a1.554 1.554 0 01.26.098 1.558 1.558 0 00-.27-.098h.01zm-50.45 28.467a4.98 4.98 0 00-.657.456l.003-.003a5.252 5.252 0 01.655-.453zm-1.845 1.716a6.67 6.67 0 01.557-.669 7.482 7.482 0 00-.749.959 3.27 3.27 0 01.192-.29zm-.496.755l.006-.013c-.092.154-.16.315-.24.475.08-.154.148-.311.234-.462zm52.218-30.966l.01-.003a1.165 1.165 0 01.185.012.964.964 0 00-.195-.009zM195.139 205.861l.012-14.312c.006-.148.031-.295.031-.443l-.031-11.644a2.434 2.434 0 00-1.03-2.25l.011.003c-.066-.035-.15-.085-.213-.12l-1.883-1.097a2.168 2.168 0 00-.286-.132 1.398 1.398 0 00-.236-.062l-.003-.004h-.006a1.934 1.934 0 00-.202-.028 1.706 1.706 0 00-.182-.012c-.053 0-.107.003-.167.006a.068.068 0 01-.034.006.037.037 0 00-.019.003.519.519 0 00-.1.01c-.054.006-.104.015-.155.025a1.46 1.46 0 00-.147.031c-.044.013-.095.025-.142.038a.901.901 0 01-.104.034l-.01.007c-.012.003-.02.003-.027.01-.05.015-.094.03-.142.05-.047.018-.097.037-.144.059l-.142.066-.144.076c-.038.022-.072.044-.114.063l-51.709 29.86a.175.175 0 00-.035.015l-.147.094-.148.094c-.054.038-.104.076-.154.11-.054.041-.104.08-.154.116a.395.395 0 00-.054.051.13.13 0 00-.025.016c-.025.022-.05.04-.075.066-.05.04-.1.088-.157.135a6 6 0 00-.155.141c-.05.044-.097.095-.15.148-.035.035-.066.073-.098.104a.086.086 0 01-.019.015.108.108 0 01-.025.029c-.044.05-.09.1-.132.15-.05.057-.094.108-.138.161-.044.054-.088.11-.132.167l-.164.207c-.072.1-.144.207-.216.312-.092.137-.18.276-.261.417a.124.124 0 01-.029.044.214.214 0 01-.018.041 3.882 3.882 0 00-.13.223c-.037.07-.071.145-.106.211-.032.06-.06.123-.091.186l-.076.17a.095.095 0 01-.012.024l-.003.01c-.02.044-.038.091-.057.132-.022.06-.048.113-.07.173-.021.056-.043.113-.062.17-.025.056-.044.119-.063.175l-.057.183a.124.124 0 00-.01.031l-.002.007c-.013.05-.032.097-.044.15-.016.063-.032.12-.047.183l-.044.188a1.702 1.702 0 00-.035.18 1.758 1.758 0 00-.031.179c-.01.056-.02.116-.025.176-.01.053-.016.116-.022.17a1.541 1.541 0 01-.016.17c0 .062-.003.112-.006.169v.16l.03 11.647v.006c0 .057.004.113.004.17.003.06.01.113.013.17a1.049 1.049 0 00.022.17c.003.053.012.106.019.163a.553.553 0 01.015.076.231.231 0 01.004.025l.018.068c.013.063.028.126.044.183a2.5 2.5 0 00.063.182l.076.182a.006.006 0 00.006.007v.012a1.58 1.58 0 00.132.24 1.052 1.052 0 00.132.156 1.179 1.179 0 00.094.12 1.678 1.678 0 00.384.317l2.093 1.217a1.274 1.274 0 01-.176-.145 2.338 2.338 0 002.672-.1l43.612-25.18zm-1.371-28.781c-.057-.02-.107-.048-.164-.063l.006.003c.054.012.101.04.158.06zm-.72-.088c-.015 0-.025-.004-.041-.004.016 0 .026.004.04.004zm-.6.12a1.035 1.035 0 00-.107.021h.003a.826.826 0 01.103-.022zm-53.244 30.701v-.003a6.203 6.203 0 00-.648.61v-.006a6.825 6.825 0 01.648-.601zm-2.194 2.958c.082-.182.176-.358.273-.537a9.053 9.053 0 00-.468 1.065c.063-.173.12-.352.195-.528zm-.32.874c-.032.107-.045.208-.073.314.028-.106.041-.207.072-.31zm-.064 14.456a2.523 2.523 0 00.101.318v-.003a2.636 2.636 0 01-.1-.315zM209.07 192.37a16.872 16.872 0 007.66-13.263c-.006-2.433-.867-4.14-2.25-4.941l.006.003-.012-.006a.05.05 0 01-.022-.013l-2.018-1.175a3.975 3.975 0 00-.592-.27c-.012-.007-.018-.013-.031-.02a5.485 5.485 0 00-.421-.113c-.038-.006-.07-.022-.11-.031l-.006-.004a4.111 4.111 0 00-.443-.06.76.76 0 00-.12-.005 1.489 1.489 0 00-.123-.007c-.053-.003-.104-.006-.154-.006-.12 0-.239 0-.365.01-.018.003-.04.003-.065.009-.022 0-.044.006-.072.006l-.202.019c-.107.016-.22.034-.333.057-.035.006-.069.015-.097.021a.324.324 0 00-.066.016l-.155.031c-.103.026-.21.057-.317.088-.07.02-.138.045-.21.07a.106.106 0 01-.042.012l-.056.019c-.1.038-.205.076-.308.12a8.35 8.35 0 00-.311.125c-.016.01-.038.02-.06.032a.427.427 0 01-.041.018c-.07.032-.135.063-.204.101-.107.047-.21.104-.315.16-.082.045-.163.086-.245.136-.028.016-.05.031-.075.044-.107.063-.217.132-.327.2l-.327.215c-.11.075-.22.157-.33.239-.113.081-.23.17-.337.254-.043.035-.088.073-.128.104l-.047.038-.167.138a9.71 9.71 0 00-.679.616c-.11.1-.217.207-.324.314-.078.076-.15.164-.23.242a.185.185 0 00-.03.035.804.804 0 00-.054.05c-.1.113-.201.22-.299.333-.1.114-.198.233-.295.35-.104.119-.199.241-.296.364a16.082 16.082 0 00-.827 1.138 19.178 19.178 0 00-.634 1.018c-.013.029-.032.057-.045.085-.094.164-.188.32-.276.488-.079.154-.16.305-.233.458-.069.136-.138.268-.195.406-.06.126-.12.245-.176.371-.006.025-.019.047-.025.075l-.003.007a3.563 3.563 0 00-.122.282c-.051.13-.101.252-.155.378-.047.122-.094.251-.14.377a6.147 6.147 0 00-.133.39 7.457 7.457 0 00-.132.402.396.396 0 00-.019.066c0 .007-.006.01-.006.016-.032.107-.066.214-.095.32-.037.14-.075.27-.107.41-.03.134-.062.27-.094.402-.025.138-.056.267-.081.402-.026.132-.044.26-.063.39a8.088 8.088 0 00-.057.386c-.016.13-.031.252-.044.378-.012.122-.019.248-.031.374a16.56 16.56 0 00-.016.37c-.003.12-.003.233-.003.35v.021a6.218 6.218 0 00.032.733c0 .031.006.06.006.091a.234.234 0 01.006.066c.009.073.012.141.025.214.012.126.031.248.053.368l.029.132a.718.718 0 00.019.1l.028.145c.034.132.066.264.1.39.01.03.025.069.038.103.01.035.022.072.035.11.018.063.04.13.062.189a3.736 3.736 0 00.154.358c.01.022.013.044.023.063.006.003.006.013.006.019.094.182.188.359.292.525a.043.043 0 01.01.013 4.75 4.75 0 00.528.657c.05.043.097.094.147.135a3.493 3.493 0 00.645.493l2.056 1.195a.305.305 0 01-.038-.028c1.402.839 3.35.738 5.501-.506zm4.373-18.603c.022.006.04.012.066.018-.063-.018-.12-.037-.183-.05h.007c.037.01.072.022.11.032zm-.337-.063a4.31 4.31 0 00-.37-.044h.025c.119.01.232.031.345.044zm-.572-.044c-.17 0-.333-.003-.503.012a.055.055 0 01.022-.003c.164-.012.324-.01.481-.01zm-.544.019h.007a5.023 5.023 0 00-.67.1.135.135 0 00.025-.006 5.192 5.192 0 01.638-.094zm-1.38.298a6.1 6.1 0 01.673-.185l.006-.007a7.366 7.366 0 00-.71.201.108.108 0 01.031-.009zm-.047.016l-.094.037c.028-.009.06-.025.094-.037zm-1.54.71c.254-.147.512-.283.757-.396.007 0 .016-.006.02-.006-.255.12-.516.252-.777.402a12.248 12.248 0 00-1.544 1.072c.007-.003.007-.01.013-.01a11.319 11.319 0 011.531-1.062zm-1.562 1.088l.009-.006c-.29.232-.556.512-.833.776.274-.264.54-.538.824-.77zm-1.437 1.345l.006-.006c-.245.258-.462.553-.691.833.226-.277.443-.569.685-.827zm-2.455 3.345a.016.016 0 00.006-.013 20.163 20.163 0 00-.912 1.805l.004-.003a18.694 18.694 0 01.902-1.79zm-2.056 5.627a15.863 15.863 0 01.44-1.908.08.08 0 00.007-.023c.103-.333.245-.657.368-.986a13.929 13.929 0 00-.965 4.787 11.917 11.917 0 01.15-1.87zm-.1 2.778c.006.089.025.17.034.261-.01-.085-.028-.166-.034-.254zm.188 1.063c.032.138.063.274.1.402a.14.14 0 00-.002-.016c-.038-.122-.066-.254-.098-.386zm.207.688c.05.13.095.261.152.38-.007-.006-.007-.021-.016-.037-.047-.107-.091-.226-.135-.343zm.305.67c.057.107.11.22.173.317 0-.003 0-.01-.006-.01-.06-.097-.113-.203-.167-.307zM171.273 234.564h.004l-.004-.003-.037-.02-2.009-1.175a3.886 3.886 0 00-.594-.27.056.056 0 00-.032-.013 4.195 4.195 0 00-.42-.12c-.039-.006-.07-.018-.108-.027h-.012a3.9 3.9 0 00-.44-.066.749.749 0 00-.12-.007c-.04-.003-.082-.006-.123-.006-.053 0-.103-.006-.154-.006-.119 0-.238.003-.364.012-.019 0-.044.007-.066.007a.295.295 0 00-.07.009 2.33 2.33 0 00-.204.019c-.11.012-.22.034-.336.053a.684.684 0 00-.097.025.423.423 0 00-.063.013c-.05.012-.1.02-.151.031a3.96 3.96 0 00-.32.092c-.07.018-.14.04-.208.066a.122.122 0 01-.044.012.178.178 0 01-.054.016 6.117 6.117 0 00-.311.123 3.33 3.33 0 00-.308.131.19.19 0 00-.063.029.36.36 0 00-.04.015c-.067.038-.136.063-.205.095l-.314.166a10.13 10.13 0 00-.246.139.872.872 0 01-.075.04l-.327.202-.327.214c-.113.081-.22.157-.33.238-.113.082-.223.17-.336.258l-.132.104a.21.21 0 01-.044.034l-.167.139-.343.295-.336.315c-.11.107-.217.216-.324.32-.078.082-.15.164-.229.245a.067.067 0 00-.028.032c-.02.019-.038.038-.057.053-.1.11-.198.22-.299.334-.097.11-.198.226-.295.342-.104.12-.198.245-.299.371l-.34.44a22.168 22.168 0 00-1.058 1.606c-.02.035-.035.073-.057.107-.016.028-.028.06-.047.089-.094.16-.186.323-.277.487-.079.15-.16.301-.232.459-.07.132-.133.27-.198.402-.06.122-.114.251-.173.371-.007.025-.019.05-.025.07a.018.018 0 00-.004.012c-.04.094-.084.191-.129.286-.044.122-.1.251-.144.374-.05.126-.098.251-.145.377-.044.126-.094.261-.135.396-.044.126-.088.264-.129.396a.608.608 0 01-.022.07c0 .006-.003.006-.003.012l-.094.32c-.038.139-.076.277-.107.415l-.094.397c-.029.138-.054.27-.082.402-.025.132-.044.264-.066.39a6.04 6.04 0 00-.053.383 7.905 7.905 0 00-.045.384c-.01.122-.022.245-.03.37-.007.126-.01.252-.014.372-.006.119-.01.235-.006.348v.022c0 .126.003.252.01.371.003.126.01.246.022.365a.416.416 0 00.009.088c.003.025.003.044.007.069.006.07.012.145.021.214q.02.184.057.368c.006.04.019.088.025.135l.019.097c.01.044.019.091.028.142.032.132.066.264.1.39l.039.106a.815.815 0 00.034.107c.022.066.04.126.066.192a2.808 2.808 0 00.154.358.219.219 0 00.019.06.023.023 0 01.006.019 5.148 5.148 0 00.292.525.027.027 0 00.01.01 4.218 4.218 0 00.528.656c.05.048.098.098.144.135a3.514 3.514 0 00.651.5l2.053 1.192a.246.246 0 01-.047-.032c1.402.842 3.354.742 5.517-.503a16.873 16.873 0 007.654-13.259c-.006-2.433-.865-4.136-2.248-4.938zm-1.037-.406c.05.013.1.031.15.044-.087-.025-.175-.056-.27-.075l.007.003a.543.543 0 01.113.028zm-.308-.056c-.132-.02-.261-.038-.396-.044h.019c.132.006.251.028.377.044zm-.758-.044a3.067 3.067 0 00-.336.006h.013a2.862 2.862 0 01.323-.006zm-.443.019a6.292 6.292 0 00-.616.097c.013-.003.019-.01.031-.01a5.705 5.705 0 01.585-.087zm-1.326.295c.204-.069.405-.12.603-.173-.207.054-.415.104-.628.18.006 0 .015-.007.025-.007zm-.051.016l.003-.003a8.17 8.17 0 00-.738.295h.006a7.515 7.515 0 01.729-.292zm-1.537.707a11.226 11.226 0 000 0 12.283 12.283 0 00-1.537 1.069l.006-.006a11.808 11.808 0 011.531-1.063zm-3.002 2.433a.087.087 0 01.013-.01c-.28.3-.535.636-.799.96.261-.321.51-.655.786-.95zm-3.822 6.403c-.075.217-.173.425-.24.641v-.003c.07-.213.164-.42.24-.638zm-.525 6.702c.01.032.016.066.028.104l-.003-.007c-.01-.031-.016-.065-.025-.097zm.126.368c.053.144.103.286.163.415a.079.079 0 00-.022-.038c-.05-.12-.094-.251-.141-.377zm.477.993l.007.01zm.682.811c-.05-.047-.094-.094-.144-.138l-.006-.01c.05.054.1.101.157.151zM184.878 139.497c-.05.031-.094.06-.145.088-.043.031-.09.062-.138.094-.047.035-.094.07-.145.1-.05.038-.094.076-.144.114a.718.718 0 00-.057.044c-.003.006-.006.006-.012.012l-.076.063c-.05.041-.1.082-.15.13-.05.04-.095.09-.145.134-.044.044-.094.088-.139.138l-.094.098-.015.016c-.01.009-.016.018-.026.028-.04.047-.088.094-.128.142-.044.05-.082.1-.126.15-.044.05-.088.104-.13.154-.046.063-.097.123-.134.186l-.013.006v.003c-.069.098-.141.195-.207.299-.088.132-.17.264-.252.402a.248.248 0 00-.019.029.07.07 0 00-.012.028c-.044.075-.088.144-.126.22-.032.069-.069.132-.1.195a2.883 2.883 0 00-.082.176c-.025.05-.054.107-.076.157a.047.047 0 01-.01.022l-.002.01c-.019.043-.038.084-.054.125a2.286 2.286 0 00-.066.16l-.06.16c-.021.057-.037.114-.06.17l-.056.17a.05.05 0 01-.003.022l-.003.013a1.691 1.691 0 01-.044.138c-.016.06-.025.116-.044.173-.016.06-.025.12-.038.176l-.038.17-.028.17c-.009.053-.016.11-.022.163a1.424 1.424 0 00-.019.163 1.374 1.374 0 00-.012.16c-.003.054-.007.104-.007.161a1.163 1.163 0 00-.006.148l.032 10.939v.003a.22.22 0 00.003.044.27.27 0 00.003.053l.01.088c.002.038.01.076.015.114l.006.072.085 13.39 1.971 1.145 10.801-16.276 40.978-23.658a7.233 7.233 0 003.285-5.696l-.028-10.939a2.313 2.313 0 00-.972-2.118l.01.003q-.986-.57-1.968-1.148a2.208 2.208 0 00-.267-.12c-.072-.024-.148-.043-.22-.062h-.01a2.043 2.043 0 00-.188-.028c-.057-.003-.117-.01-.174-.01-.05 0-.1.003-.153.007-.013 0-.025.003-.038.003l-.012.003-.095.01c-.05.005-.1.012-.145.02-.047.014-.09.023-.132.033-.05.012-.094.025-.138.037-.035.01-.069.022-.097.032a.017.017 0 00-.016.006.082.082 0 00-.025.003c-.041.016-.085.034-.132.05-.041.02-.088.038-.132.06-.04.019-.088.038-.132.063a2.035 2.035 0 00-.139.07c-.03.018-.069.037-.103.056l-48.589 28.052zm-.342 3.596l.003-.007c-.082.145-.145.293-.22.44.072-.144.138-.288.217-.433zm52.79-30.938c.066.013.117.05.18.07a1.369 1.369 0 00-.186-.07h.007zm-.411-.022c-.05.003-.101-.009-.158-.003l.007-.003c.053-.003.1.01.15.006zm-50.037 28.49a5.007 5.007 0 00-.655.455v-.003a5.288 5.288 0 01.655-.453zm-1.29 1.043c-.147.157-.282.333-.418.502.136-.17.27-.342.419-.499zm-.556.673c-.003 0-.006.006-.01.012.004-.006.007-.012.01-.012zM134.357 144.699c0 .057.003.117.003.17.003.056.01.11.012.163a1.042 1.042 0 00.023.173c.002.05.012.11.018.167a.498.498 0 01.016.072.245.245 0 01.003.025l.02.073a2.273 2.273 0 00.106.364l.075.18c0 .002 0 .006.007.009v.01a1.458 1.458 0 00.132.238 1.076 1.076 0 00.132.16c.028.041.062.082.094.12a1.583 1.583 0 00.383.314l2.094 1.217a1.15 1.15 0 01-.195-.16 2.315 2.315 0 002.691-.085l43.612-25.18 11.555 4.018.013-14.309c.006-.151.031-.295.031-.44l-.031-11.644a2.442 2.442 0 00-1.031-2.256l.012.003c-.066-.035-.15-.085-.213-.12-.63-.365-1.258-.732-1.883-1.097a1.866 1.866 0 00-.522-.195h-.003l-.006-.003a1.862 1.862 0 00-.202-.025 1.13 1.13 0 00-.182-.013c-.053 0-.107.003-.167.007-.01.003-.025.003-.034.006h-.019a.949.949 0 00-.1.01c-.054.005-.104.015-.155.024a1.498 1.498 0 00-.147.035c-.044.01-.095.025-.142.038-.035.013-.066.022-.104.034l-.006.004a.129.129 0 00-.031.009c-.05.019-.094.034-.142.05-.047.022-.097.041-.144.063a1.414 1.414 0 00-.142.07c-.047.021-.094.043-.144.072-.038.021-.073.04-.114.06l-51.709 29.859a.178.178 0 00-.035.016l-.147.094a4.17 4.17 0 00-.148.097c-.054.035-.104.072-.154.108l-.154.116a.662.662 0 01-.054.05.149.149 0 00-.025.019c-.025.019-.05.04-.075.063-.05.044-.1.088-.157.135-.05.047-.104.097-.155.141l-.15.148c-.035.035-.066.072-.098.107l-.019.016a.191.191 0 01-.025.028c-.044.047-.09.097-.132.148-.05.056-.094.106-.138.16-.044.057-.088.11-.132.166-.054.07-.107.139-.164.208-.072.1-.144.207-.216.314-.092.139-.18.277-.261.418a.228.228 0 01-.029.041.463.463 0 01-.018.045c-.048.072-.089.147-.13.22a7.336 7.336 0 00-.106.213c-.032.06-.06.12-.091.182l-.076.17a.064.064 0 01-.012.025l-.003.01c-.02.044-.038.09-.057.135-.022.056-.048.113-.07.17-.021.056-.043.113-.062.17-.025.06-.044.119-.063.179l-.057.179a.128.128 0 00-.01.031l-.002.007c-.013.05-.032.1-.044.15l-.047.183c-.016.063-.028.125-.044.188-.016.063-.025.12-.035.183a1.703 1.703 0 00-.031.176 2.9 2.9 0 00-.025.176 2.72 2.72 0 00-.022.172 1.603 1.603 0 01-.016.17c0 .06-.003.117-.006.17v.16l.03 11.644zm2.27 2.298c.034.107.059.22.1.314v-.009c-.041-.091-.066-.201-.1-.305zm57.198-49.01a1.379 1.379 0 00-.22-.081h.005a1.554 1.554 0 01.215.082zm-.767-.11a.136.136 0 00-.051 0 .136.136 0 01.05 0zm-.617.12c-.031.01-.063.01-.1.022h.003c.034-.013.066-.013.097-.022zM139.204 128.7l.003-.003a6.519 6.519 0 00-.65.607 7.28 7.28 0 01.647-.604zm-2.194 2.958c.075-.164.163-.327.252-.49a9.026 9.026 0 00-.44 1.006c.062-.17.116-.346.188-.516zm-.32.877c-.039.116-.054.23-.082.349.028-.117.043-.23.081-.346zM199.344 108.427c0 .028.007.057.007.088a.233.233 0 01.006.066c.009.072.012.145.025.214.012.125.031.248.053.367l.029.135a.974.974 0 00.019.101l.028.142c.034.132.066.264.1.39a.98.98 0 00.038.103c.01.035.022.073.035.11.018.063.04.126.062.192.044.123.1.242.154.362.01.015.013.037.023.056a.023.023 0 01.006.019c.094.182.188.359.292.525l.01.01a4.429 4.429 0 00.528.66c.05.047.097.094.147.135a3.352 3.352 0 00.645.493l2.056 1.198c-.019-.01-.032-.029-.044-.035 1.398.843 3.35.745 5.507-.503a16.87 16.87 0 007.66-13.262c-.006-2.433-.867-4.137-2.25-4.938h.006l-.012-.006a.05.05 0 01-.022-.013l-2.018-1.176a4.006 4.006 0 00-.592-.27c-.012-.003-.018-.013-.031-.013a3.097 3.097 0 00-.421-.12c-.038-.005-.07-.021-.11-.027l-.006-.003a3.542 3.542 0 00-.443-.064c-.039-.003-.082-.003-.12-.006-.04-.003-.082-.003-.122-.006-.054 0-.105-.006-.155-.006-.12 0-.239.003-.365.012a.597.597 0 00-.065.006c-.022 0-.044.007-.072.007l-.202.019a7.34 7.34 0 00-.333.056c-.035.007-.069.02-.097.025a.395.395 0 00-.066.013c-.05.013-.101.019-.155.031-.103.029-.21.057-.317.089-.07.021-.138.046-.21.068a.101.101 0 01-.041.013l-.057.019c-.1.038-.205.075-.308.12-.1.037-.208.081-.311.125a.263.263 0 01-.06.032l-.041.019c-.07.031-.135.062-.204.097-.107.05-.21.107-.315.164-.081.043-.163.09-.245.138-.028.016-.05.028-.075.044-.107.062-.217.128-.327.198-.107.069-.214.138-.327.214-.11.078-.22.157-.33.238a7.09 7.09 0 00-.337.258 1.373 1.373 0 00-.128.107.251.251 0 00-.047.031c-.057.05-.11.092-.167.139a13.67 13.67 0 00-.679.613c-.11.103-.217.21-.324.317-.078.082-.15.164-.23.239l-.03.038a.435.435 0 00-.054.056c-.1.107-.201.214-.299.327-.1.114-.198.233-.295.35-.104.119-.199.241-.296.367-.116.141-.23.292-.343.444a19.346 19.346 0 00-1.06 1.606c-.018.034-.036.069-.058.103-.013.029-.032.06-.045.085-.094.164-.188.324-.276.487-.079.154-.16.305-.233.463a5.17 5.17 0 00-.195.402c-.06.126-.12.245-.176.37-.006.026-.019.048-.025.076l-.003.006c-.044.095-.088.189-.122.283-.051.126-.101.252-.155.378l-.14.374a8.017 8.017 0 00-.133.393 7.365 7.365 0 00-.132.402.35.35 0 00-.019.07c0 .005-.006.008-.006.012-.032.107-.066.213-.095.32-.037.138-.075.274-.106.409l-.095.402c-.025.135-.056.27-.081.403a8.295 8.295 0 00-.063.39 8.346 8.346 0 00-.057.39c-.016.125-.031.25-.044.373-.012.13-.019.252-.031.374-.007.126-.013.252-.016.374-.003.117-.003.233-.003.35v.021a6.268 6.268 0 00.032.733zm2.069 1.352v-.006c.006.087.025.17.034.257-.01-.082-.028-.163-.034-.251zm.179 1.024c.035.148.066.296.11.434l-.003-.012c-.041-.132-.072-.277-.107-.422zm.191.657c.057.155.114.305.177.45a.292.292 0 00-.016-.044 4.438 4.438 0 01-.16-.406zm.321.72c.063.113.12.227.183.327 0-.003 0-.003-.007-.006-.063-.1-.113-.214-.176-.321zm11.339-17.528l.122.038a2.719 2.719 0 00-.232-.069c.037.006.072.022.11.031zm-1.11-.1a2.308 2.308 0 00-.295.006.028.028 0 00.015-.003 2.715 2.715 0 01.28-.003zm-.459.025c-.18.025-.355.05-.537.088l.015-.006c.176-.038.35-.057.522-.082zm-1.088.239c-.066.019-.125.031-.188.053a.017.017 0 01.012-.003c.06-.022.114-.031.176-.05zm-.223.063c-.047.019-.097.044-.147.06.05-.016.097-.041.147-.06zm-1.54.71c.254-.145.512-.276.757-.396h.007c-.252.116-.503.248-.764.396a12.397 12.397 0 00-1.544 1.072c.007-.003.007-.01.013-.01a11.383 11.383 0 011.531-1.062zm-1.562 1.088c-.057.044-.107.104-.164.15.057-.046.107-.103.164-.15zm-3.892 4.69l.006-.007a19.008 19.008 0 00-.912 1.799 19.538 19.538 0 01.906-1.792zm-2.056 5.626a15.751 15.751 0 01.44-1.908.053.053 0 00.007-.022c.107-.34.251-.678.377-1.018a14.026 14.026 0 00-.974 4.819 11.949 11.949 0 01.15-1.87zM165.867 173.65a16.883 16.883 0 007.654-13.262c-.006-2.433-.865-4.137-2.248-4.938h.004l-.004-.004-.037-.018-2.009-1.17a3.434 3.434 0 00-.594-.276.266.266 0 00-.032-.013 2.991 2.991 0 00-.42-.116c-.039-.01-.07-.022-.108-.028l-.012-.007a3.905 3.905 0 00-.44-.062.752.752 0 01-.12-.007c-.04-.003-.082-.003-.123-.006-.053 0-.103-.007-.154-.007-.119 0-.238.007-.364.013-.019 0-.044.007-.066.007a.566.566 0 00-.07.009 1.571 1.571 0 00-.204.022c-.11.012-.22.031-.336.053-.028.003-.063.016-.097.022-.02.007-.044.007-.063.013-.05.013-.1.019-.151.031-.107.032-.214.057-.32.091-.07.02-.14.044-.208.067-.013.006-.032.012-.044.018a.302.302 0 01-.054.013c-.104.04-.207.078-.311.12-.1.04-.207.08-.308.128a.639.639 0 00-.063.031c-.012.004-.025.013-.04.016-.067.038-.136.066-.205.101-.107.05-.21.107-.314.163a9.906 9.906 0 00-.246.135c-.025.016-.05.029-.075.044l-.327.199a11.451 11.451 0 00-.657.452c-.113.082-.223.17-.336.258-.044.035-.088.069-.132.107-.016.01-.028.025-.044.034-.057.048-.113.092-.167.139a10.967 10.967 0 00-.68.613c-.109.1-.216.21-.323.314-.078.082-.15.164-.229.242a.203.203 0 00-.028.035l-.057.056c-.1.107-.198.22-.299.33-.097.113-.198.23-.295.35-.104.119-.198.238-.299.364-.113.145-.226.295-.34.443a22.03 22.03 0 00-1.058 1.606c-.02.038-.035.07-.057.104-.016.028-.028.06-.047.088-.094.16-.186.324-.277.487-.079.151-.16.302-.232.46-.07.131-.133.27-.198.401-.06.126-.114.252-.173.375-.007.022-.019.047-.025.069-.004.003-.004.003-.004.01-.04.094-.084.188-.129.285-.044.123-.1.252-.144.374-.05.126-.098.252-.145.378-.044.131-.094.264-.135.396-.044.129-.088.26-.129.396a.608.608 0 01-.022.069c0 .006-.003.01-.003.016q-.047.155-.094.32c-.038.136-.076.27-.107.409l-.094.402c-.029.135-.054.267-.082.4-.025.132-.044.263-.066.389a5.693 5.693 0 00-.053.39c-.02.126-.032.252-.045.374-.01.126-.022.255-.03.377-.007.123-.01.249-.014.371-.006.117-.01.236-.006.35v.021c0 .123.003.249.01.368.003.126.01.245.022.364a.394.394 0 00.009.089c.003.025.003.047.007.069.006.07.012.145.021.214a3.442 3.442 0 00.057.364c.006.047.019.095.025.138l.019.098.028.141c.032.133.066.264.1.39l.039.107a.999.999 0 00.034.107c.022.066.04.132.066.195a3 3 0 00.154.358.2.2 0 00.019.057.026.026 0 01.006.019 5.624 5.624 0 00.292.528l.01.01a4.415 4.415 0 00.528.656l.144.139a3.61 3.61 0 00.651.493l2.053 1.192c-.012-.004-.025-.02-.035-.026 1.4.837 3.348.736 5.505-.506zm4.369-18.606l.132.041c-.081-.022-.163-.053-.245-.072a.662.662 0 00.113.031zm-.522-.078c-.057-.01-.113-.016-.17-.022h.007c.056.006.106.012.163.022zm-.663-.022c-.072.006-.142 0-.214.006h.01c.069-.006.135 0 .204-.006zm-.519.05c-.135.019-.27.035-.408.063a.022.022 0 00.018-.007c.133-.025.265-.037.39-.056zm-.937.208c-.069.021-.138.037-.207.062a.016.016 0 01.013-.006c.066-.025.132-.038.194-.056zm-.245.069h.003c-.047.015-.094.043-.14.056.046-.013.093-.041.137-.056zm-1.537.713a11.948 11.948 0 00-1.537 1.066l.006-.007a11.49 11.49 0 011.531-1.059zm-3.002 2.43c.006 0 .006-.006.01-.006-.236.251-.447.537-.67.804.22-.264.427-.547.66-.798zm-3.86 6.507c-.063.182-.145.358-.201.537.056-.179.138-.361.201-.537zm-.66 5.862c.006.035.01.079.019.114v-.003a1.023 1.023 0 01-.02-.11zm.195.821l.003.012zm.113.314c.05.132.1.264.154.39a.072.072 0 00-.022-.044c-.047-.113-.088-.226-.132-.346zm.421.874a.535.535 0 00.057.104l-.003-.003a.756.756 0 01-.054-.101zm.585.76v-.002c.044.05.094.094.144.141l-.144-.138z"/>
                </g>
                <path
                    fill="#abbec5"
                    d="M238.87 197.343L236.902 196.201 236.905 197.858 238.873 199.002 238.87 197.343z"
                />
                <path
                    fill="#abbec5"
                    d="M238.857 193.042L236.89 191.901 236.893 193.558 238.86 194.702 238.857 193.042z"
                />
                <path
                    fill="#abbec5"
                    d="M238.845 188.534L236.877 187.39 236.883 189.047 238.851 190.188 238.845 188.534z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.873 199.002L236.905 197.858 187.409 226.438 189.38 227.579 238.873 199.002z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.87 197.343L236.902 196.201 187.405 224.778 189.373 225.923 238.87 197.343z"
                />
                <path
                    fill="#3190a4"
                    d="M189.373 225.923L187.405 224.778 187.409 226.438 189.38 227.579 189.373 225.923z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.86 194.702L236.893 193.558 187.399 222.138 189.367 223.279 238.86 194.702z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.857 193.042L236.89 191.901 187.393 220.478 189.361 221.622 238.857 193.042z"
                />
                <path
                    fill="#3190a4"
                    d="M189.361 221.622L187.393 220.478 187.399 222.138 189.367 223.279 189.361 221.622z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.851 190.188L236.883 189.047 187.387 217.624 189.355 218.768 238.851 190.188z"
                />
                <path
                    fill="#3190a4"
                    d="M189.345 217.111L187.38 215.964 187.387 217.624 189.355 218.768 189.345 217.111z"
                />
                <path
                    fill="#7d3fd4"  /*190 cyan 265*/
                    d="M189.345 217.111L189.355 218.768 238.851 190.188 238.845 188.534 189.345 217.111z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.845 188.534L236.877 187.39 187.38 215.964 189.345 217.111 238.845 188.534z"
                />
                <path
                    fill="#f5d9fc"  /*228 light blue 288*/
                    d="M238.449 184.753c1.823-1.05 3.3-.208 3.307 1.889l.03 10.94a7.224 7.224 0 01-3.287 5.69l-40.978 23.663-10.801 16.277-.088-13.392c-.012-.132-.035-.239-.038-.377l-.028-10.939a7.234 7.234 0 013.291-5.696zm-49.094 34.015l49.496-28.58-.006-1.654-49.5 28.577.01 1.657zm.025 8.81l49.493-28.576-.003-1.66-49.497 28.58.007 1.657zm-.013-4.299l49.493-28.577-.003-1.66-49.496 28.58.006 1.657z"
                />
                <path
                    fill="#7d3fd4"
                    d="M189.373 225.923L189.38 227.579 238.873 199.002 238.87 197.343 189.373 225.923z"
                />
                <path
                    fill="#7d3fd4"
                    d="M189.361 221.622L189.367 223.279 238.86 194.702 238.857 193.042 189.361 221.622z"
                />
                <path
                    fill="#cba9eb"  /*197 cyan 271*/
                    d="M184.601 217.212c0-.053.004-.107.007-.16.003-.054.006-.107.012-.16l.019-.164c.007-.05.013-.11.025-.167.007-.053.02-.107.026-.163l.037-.173c.013-.053.026-.116.038-.173.019-.057.032-.113.05-.176.01-.04.025-.088.038-.132l.003-.013a.174.174 0 01.006-.025c.019-.056.041-.113.06-.175a1.391 1.391 0 01.057-.164c.019-.05.037-.107.056-.164.019-.053.044-.103.066-.157.016-.044.035-.085.054-.129l.006-.009c0-.006.006-.013.01-.019a6.733 6.733 0 01.257-.528 1.878 1.878 0 01.123-.22.124.124 0 00.012-.032.148.148 0 00.02-.03c.081-.136.163-.271.25-.403.07-.101.139-.195.211-.296l.007-.01c.044-.062.094-.122.141-.182.038-.053.082-.106.126-.16.044-.047.082-.094.129-.144a1.753 1.753 0 01.128-.142c.007-.01.02-.019.026-.028a.064.064 0 00.012-.02c.032-.03.063-.065.095-.093.044-.05.094-.095.138-.139a2.008 2.008 0 01.151-.138 1.857 1.857 0 01.144-.129.648.648 0 01.076-.06c.006-.006.012-.012.019-.012a.213.213 0 01.05-.044c.05-.038.1-.079.148-.114.047-.034.097-.068.14-.103.052-.028.095-.06.143-.091.05-.029.09-.063.14-.085a.213.213 0 01.032-.022l48.592-28.052a.912.912 0 01.103-.057c.048-.028.092-.05.136-.072.047-.022.09-.044.135-.063.047-.022.088-.04.129-.057l.138-.05.016-.006.019-.006a.973.973 0 01.097-.028c.044-.013.091-.029.138-.038.041-.013.089-.022.132-.035.047-.006.095-.016.142-.022.034-.006.066-.006.097-.01a.031.031 0 01.013-.003h.037a1.33 1.33 0 01.154-.006c.06 0 .117.006.173.006.066.007.126.02.189.029h.01c.078.019.147.04.223.066a1.724 1.724 0 01.264.12c.66.383 1.313.76 1.97 1.144a1.64 1.64 0 00-.49-.183l-.006-.003a2.039 2.039 0 00-.556-.029h-.013a2.476 2.476 0 00-.607.139h-.012a4.17 4.17 0 00-.664.305l-48.59 28.055a5.08 5.08 0 00-.654.453.153.153 0 01-.023.022 5.6 5.6 0 00-.6.56c-.006.003-.013.006-.013.012a7.203 7.203 0 00-.556.666 8.518 8.518 0 00-.48.736.067.067 0 00-.013.022 8.167 8.167 0 00-.396.776v.003a6.927 6.927 0 00-.3.815c0 .003-.002.003-.002.01a5.637 5.637 0 00-.255 1.621l.028 10.939c.003.139.025.245.038.377l.088 13.392-1.968-1.145-.088-13.391a.57.57 0 00-.006-.075c-.006-.038-.006-.076-.012-.113a.652.652 0 01-.013-.085v-.054a.213.213 0 01-.003-.044v-.003l-.029-10.942z"
                />
                <path
                    fill="#abbec5"
                    d="M195.207 183.844L193.114 182.631 193.12 184.391 195.214 185.608 195.207 183.844z"
                />
                <path
                    fill="#abbec5"
                    d="M195.195 179.267L193.101 178.051 193.108 179.814 195.201 181.034 195.195 179.267z"
                />
                <path
                    fill="#abbec5"
                    d="M195.182 174.464L193.089 173.245 193.095 175.014 195.189 176.231 195.182 174.464z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.214 185.608L193.12 184.391 140.436 214.807 142.53 216.024 195.214 185.608z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.207 183.844L193.114 182.631 140.433 213.044 142.523 214.26 195.207 183.844z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.523 214.26L142.53 216.024 195.214 185.608 195.207 183.844 142.523 214.26z"
                />
                <path
                    fill="#3190a4"
                    d="M142.523 214.26L140.433 213.044 140.436 214.807 142.53 216.024 142.523 214.26z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.201 181.034L193.108 179.814 140.424 210.234 142.517 211.45 195.201 181.034z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.195 179.267L193.101 178.051 140.417 208.467 142.511 209.684 195.195 179.267z"
                />
                <path
                    fill="#3190a4"
                    d="M142.511 209.684L140.417 208.467 140.424 210.234 142.517 211.45 142.511 209.684z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.189 176.231L193.095 175.014 140.411 205.431 142.505 206.65 195.189 176.231z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.182 174.464L193.089 173.245 140.405 203.667 142.498 204.88 195.182 174.464z"
                />
                <path
                    fill="#3190a4"
                    d="M142.498 204.88L140.405 203.667 140.411 205.431 142.505 206.65 142.498 204.88z"
                />
                <path
                    fill="#f5d9fc"
                    d="M194.607 170.535c1.94-1.119 3.518-.233 3.527 2l.032 11.646c0 .144-.029.292-.035.443l-.013 14.309-11.552-4.017-43.615 25.178c-1.936 1.12-3.514.227-3.517-2.005l-.035-11.643a7.71 7.71 0 013.499-6.06zm-52.09 40.915l52.684-30.416-.006-1.767-52.684 30.417.006 1.766zm.013 4.574l52.684-30.416-.007-1.764-52.684 30.416.007 1.764zm-.025-9.374l52.684-30.419-.007-1.767-52.684 30.416.007 1.77z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.511 209.684L142.517 211.45 195.201 181.034 195.195 179.267 142.511 209.684z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.498 204.88L142.505 206.65 195.189 176.231 195.182 174.464 142.498 204.88z"
                />
                <path
                    fill="#cba9eb"
                    d="M137.306 205.069c.006-.053.009-.113.012-.17a1.526 1.526 0 01.013-.17c.003-.056.012-.113.018-.17.007-.062.02-.119.025-.175.01-.063.02-.12.032-.18.012-.059.025-.122.035-.182.015-.06.028-.122.046-.185.013-.063.032-.123.045-.183l.044-.15.006-.01a.127.127 0 01.006-.028c.016-.06.038-.12.057-.183.019-.056.037-.116.063-.176a1.72 1.72 0 00.063-.172c.025-.057.05-.11.072-.173.015-.044.038-.088.056-.13l.003-.012c.007-.006.007-.013.013-.025l.076-.166c.03-.064.056-.126.088-.183.037-.072.072-.145.11-.214.04-.075.084-.15.125-.226a.208.208 0 00.022-.038.349.349 0 00.026-.044c.084-.144.17-.283.263-.415a6.32 6.32 0 01.22-.32c.05-.066.108-.132.158-.202l.132-.17c.044-.05.088-.106.138-.156l.132-.152c.013-.009.019-.018.029-.025a.07.07 0 01.015-.018c.035-.035.07-.07.1-.107.051-.05.101-.1.152-.148.05-.047.1-.094.154-.141.053-.048.103-.088.154-.136.025-.021.053-.04.078-.062a.14.14 0 01.022-.02.641.641 0 00.057-.046c.05-.041.1-.076.154-.117.05-.037.104-.072.154-.11.05-.031.097-.062.148-.1.05-.025.097-.057.147-.088a.33.33 0 01.035-.02l51.71-29.856a.957.957 0 00.11-.062c.05-.025.1-.05.144-.076.05-.019.094-.044.145-.066.05-.019.094-.04.141-.06.047-.018.098-.034.141-.053a.113.113 0 00.029-.01l.01-.002.1-.032c.05-.015.104-.032.148-.04a1.406 1.406 0 01.144-.032 1.335 1.335 0 01.155-.025c.034-.007.069-.007.103-.013h.016a.073.073 0 01.037-.006c.057 0 .114-.006.167-.004a2.424 2.424 0 01.387.038l.006.003a1.356 1.356 0 01.233.064 1.944 1.944 0 01.289.131c.626.365 1.257.73 1.88 1.094.062.038.15.088.213.12a2.032 2.032 0 00-.521-.195h-.007a2.047 2.047 0 00-.594-.028h-.01a2.883 2.883 0 00-.653.14c-.006 0-.006.004-.006.004a3.674 3.674 0 00-.714.33l-51.71 29.85a5.314 5.314 0 00-.697.484c-.007.006-.01.013-.016.013a7.77 7.77 0 00-.648.604.012.012 0 01-.006.009 8.277 8.277 0 00-1.1 1.493.259.259 0 00-.019.031 8.889 8.889 0 00-.421.824 8.7 8.7 0 00-.314.868l-.007.006a6.05 6.05 0 00-.27 1.729l.035 11.643a4.322 4.322 0 00.069.755.08.08 0 01.003.025 3.032 3.032 0 00.201.616.006.006 0 00.006.006 1.814 1.814 0 00.261.412c.035.04.063.082.1.12a1.66 1.66 0 00.381.317c-.695-.409-1.396-.811-2.093-1.22a1.63 1.63 0 01-.38-.314 1.214 1.214 0 01-.099-.12 1.376 1.376 0 01-.132-.157 4.594 4.594 0 01-.128-.239l-.003-.012a.006.006 0 00-.007-.007l-.075-.182c-.019-.056-.044-.12-.06-.182-.016-.06-.035-.12-.047-.183-.006-.021-.01-.05-.019-.075v-.022a.558.558 0 01-.015-.072 2.926 2.926 0 01-.023-.17 1.581 1.581 0 01-.022-.167c-.003-.053-.01-.106-.01-.166 0-.057-.002-.113-.005-.17v-.01l-.031-11.646z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-5)">
                    <path
                        fill="#852858"
                        d="M214.785 174.77l-2.056-1.192a2.671 2.671 0 01.896.886l2.053 1.195a2.656 2.656 0 00-.893-.89z"
                    />
                    <path
                        fill="#8a295c"
                        d="M215.678 175.659l-2.053-1.195a4.392 4.392 0 01.217.396l2.053 1.195a3.173 3.173 0 00-.217-.396z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M215.895 176.055l-2.053-1.195c.053.114.1.233.15.353l2.05 1.194a3.045 3.045 0 00-.147-.352z"
                    />
                    <path
                        fill="#942c63"
                        d="M216.042 176.407l-2.05-1.194c.039.106.076.22.108.333l2.05 1.194c-.03-.113-.07-.226-.108-.333z"
                    />
                    <path
                        fill="#992e66"
                        d="M216.15 176.74l-2.05-1.194c.031.106.06.214.081.327l2.056 1.194a5.196 5.196 0 00-.088-.327z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M216.237 177.067l-2.056-1.194c.025.1.047.207.067.317l2.052 1.191c-.019-.107-.038-.213-.063-.314z"
                    />
                    <path
                        fill="#a3316d"
                        d="M216.3 177.381l-2.052-1.19c.015.078.025.153.034.229l2.056 1.194-.038-.233z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-6)">
                    <path
                        fill="#818184"
                        d="M214.785 174.77l-2.056-1.192a1.87 1.87 0 00-.37-.17l2.055 1.191a2.488 2.488 0 01.371.17z"
                    />
                    <path
                        fill="#868689"
                        d="M214.414 174.6l-2.056-1.192a1.671 1.671 0 00-.29-.082l2.05 1.195a1.883 1.883 0 01.296.078z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M214.118 174.52l-2.05-1.194-.106-.018 2.056 1.194c.032.003.069.013.1.019z"
                    />
                </g>
                <g clipPath="url(#clip-path-7)">
                    <path
                        fill="#b8377a"
                        d="M214.338 172.962l-2.052-1.194v.006c0 .034-.003.069-.003.1l2.055 1.195v-.107z"
                    />
                </g>
                <path
                    fill="#dc4193"
                    d="M216.338 177.614L214.282 176.42 205.688 181.386 207.744 182.578 216.338 177.614z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-8)">
                    <path
                        fill="#852858"
                        d="M213.666 171.478l-2.056-1.195a1.248 1.248 0 01.402.39l2.05 1.195a1.2 1.2 0 00-.396-.39z"
                    />
                    <path
                        fill="#8a295c"
                        d="M214.062 171.868l-2.05-1.195c.032.05.057.104.088.16l2.05 1.192a.96.96 0 00-.088-.157z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M214.15 172.025l-2.05-1.192a1.165 1.165 0 01.05.136l2.056 1.188c-.019-.044-.037-.091-.056-.132z"
                    />
                    <path
                        fill="#942c63"
                        d="M214.206 172.157l-2.056-1.188a.65.65 0 01.045.12l2.053 1.194a2.073 2.073 0 00-.041-.126z"
                    />
                    <path
                        fill="#992e66"
                        d="M214.248 172.283l-2.053-1.195c.012.038.018.076.031.12l2.056 1.191c-.013-.04-.022-.079-.035-.116z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M214.282 172.4l-2.056-1.192c.006.034.013.075.022.113l2.053 1.195-.019-.117z"
                    />
                    <path
                        fill="#a3316d"
                        d="M214.3 172.516l-2.052-1.195c.003.034.01.072.016.11l2.056 1.191-.02-.106z"
                    />
                    <path
                        fill="#a83270"
                        d="M214.32 172.622l-2.056-1.191c.006.034.01.072.012.113l2.056 1.191a1.441 1.441 0 01-.012-.113z"
                    />
                    <path
                        fill="#ad3474"
                        d="M214.332 172.735l-2.056-1.191a.627.627 0 01.007.11l2.055 1.195c0-.038-.006-.076-.006-.114z"
                    />
                    <path
                        fill="#b33577"
                        d="M214.338 172.849l-2.055-1.195c0 .038 0 .075.003.114l2.052 1.194v-.113z"
                    />
                    <path
                        fill="#b8377a"
                        d="M214.338 172.962l-2.052-1.194v.006c0 .034-.003.069-.003.1l2.055 1.195v-.107z"
                    />
                    <path
                        fill="#bd387e"
                        d="M214.338 173.069l-2.055-1.195v.107l2.049 1.195a.623.623 0 00.006-.107z"
                    />
                    <path
                        fill="#c23a81"
                        d="M214.332 173.176l-2.05-1.195c-.006.032-.009.072-.012.107l2.056 1.195c0-.038.006-.076.006-.107z"
                    />
                    <path
                        fill="#c73b85"
                        d="M214.326 173.283l-2.056-1.195c-.006.038-.006.07-.012.107l2.055 1.195c.004-.039.007-.073.013-.107z"
                    />
                    <path
                        fill="#cc3d88"
                        d="M214.313 173.39l-2.055-1.195c-.007.038-.01.075-.02.113l2.056 1.191.02-.11z"
                    />
                    <path
                        fill="#d13e8b"
                        d="M214.294 173.499l-2.055-1.191c0 .038-.01.075-.013.113l2.056 1.195a.818.818 0 01.012-.117z"
                    />
                    <path
                        fill="#d6408f"
                        d="M214.282 173.616l-2.056-1.195a.814.814 0 00-.025.116l2.05 1.195c.012-.038.018-.079.03-.116z"
                    />
                    <path
                        fill="#db4192"
                        d="M214.25 173.732l-2.05-1.195c-.012.041-.018.082-.03.126l2.055 1.192c.006-.041.02-.082.026-.123z"
                    />
                    <path
                        fill="#e04396"
                        d="M214.225 173.855l-2.055-1.192c-.01.041-.02.085-.032.126l2.05 1.191a.816.816 0 00.037-.125z"
                    />
                    <path
                        fill="#e64499"
                        d="M214.187 173.98l-2.049-1.191a5.17 5.17 0 00-.038.129l2.053 1.191a.934.934 0 00.034-.129z"
                    />
                    <path
                        fill="#eb469c"
                        d="M214.153 174.11l-2.053-1.192c-.012.04-.028.088-.044.132l2.056 1.188c.013-.041.025-.082.041-.129z"
                    />
                    <path
                        fill="#f047a0"
                        d="M214.112 174.238l-2.056-1.188a.972.972 0 01-.044.126l2.056 1.197c.013-.044.028-.088.044-.135z"
                    />
                    <path
                        fill="#f549a3"
                        d="M214.068 174.373l-2.056-1.197a2.126 2.126 0 01-.05.132l2.056 1.194a1.8 1.8 0 01.05-.129z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-9)">
                    <path
                        fill="#f9fafd"
                        d="M210.038 176.803l-2.056-1.195c-.031.038-.062.082-.094.123l2.056 1.191c.031-.037.063-.081.094-.119z"
                    />
                    <path
                        fill="#fafafd"
                        d="M209.944 176.922l-2.056-1.19c-.078.11-.157.216-.233.335l2.053 1.188c.072-.112.154-.22.236-.333z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M209.708 177.255l-2.053-1.188c-.135.195-.263.4-.39.613l2.056 1.192c.12-.214.252-.415.387-.617z"
                    />
                    <path
                        fill="#fafafd"
                        d="M209.321 177.872l-2.055-1.192c-.076.13-.154.268-.227.4l2.056 1.2c.072-.138.145-.276.226-.408z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M209.095 178.28l-2.056-1.2c-.05.1-.1.194-.144.292l2.053 1.191c.047-.097.097-.191.147-.282z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M208.948 178.563l-2.053-1.19a6.096 6.096 0 00-.129.26l2.053 1.194c.043-.094.084-.179.129-.264zM208.819 178.827l-2.053-1.194a5.283 5.283 0 00-.11.248l2.05 1.195c.037-.085.075-.167.113-.249z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M208.705 179.076l-2.05-1.195a6.07 6.07 0 00-.112.255l2.056 1.194c.031-.088.072-.17.107-.254z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M208.599 179.33l-2.056-1.194c-.038.091-.072.179-.107.267l2.056 1.192c.034-.088.069-.177.107-.265z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M208.492 179.595l-2.056-1.192c-.035.091-.07.186-.1.28l2.049 1.188.107-.276z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M208.385 179.87l-2.05-1.187c-.037.094-.069.188-.104.289l2.053 1.194c.032-.1.07-.194.1-.295z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M208.284 180.166l-2.053-1.194c-.034.1-.069.204-.097.308l2.05 1.194c.031-.106.065-.207.1-.308z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M208.184 180.474l-2.05-1.194c-.031.107-.069.21-.094.32l2.056 1.195c.025-.11.056-.214.088-.32z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M208.096 180.795l-2.056-1.194c-.032.107-.057.217-.088.327l2.056 1.191c.025-.107.056-.217.088-.324z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M208.008 181.119l-2.056-1.191c-.026.11-.054.22-.076.333l2.056 1.188c.019-.11.05-.22.076-.33z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M207.932 181.45l-2.056-1.19c-.025.108-.044.218-.07.328l2.054 1.194c.022-.113.047-.22.072-.333z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M207.86 181.782l-2.053-1.194-.056.33 2.056 1.194c.012-.11.034-.22.053-.33z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M207.807 182.112l-2.056-1.194-.048.33 2.053 1.195c.013-.114.031-.22.05-.33z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M207.756 182.443l-2.053-1.195c-.003.044-.009.091-.015.138l2.056 1.192c.002-.044.006-.092.012-.135z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-10)">
                    <path
                        fill="#818184"
                        d="M213.666 171.478l-2.056-1.195a.94.94 0 00-.182-.084l2.052 1.194a.947.947 0 01.186.085z"
                    />
                    <path
                        fill="#868689"
                        d="M213.48 171.393l-2.052-1.194c-.05-.016-.107-.035-.164-.047l2.056 1.194a1.596 1.596 0 01.16.047z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M213.32 171.346l-2.056-1.194c-.044-.004-.088-.013-.132-.016l2.056 1.191c.041.003.085.013.132.019z"
                    />
                    <path
                        fill="#909093"
                        d="M213.188 171.327l-2.056-1.191c-.04-.004-.081-.004-.123-.004l2.06 1.189c.037 0 .078.006.119.006z"
                    />
                    <path
                        fill="#959598"
                        d="M213.068 171.32l-2.059-1.188h-.11l2.06 1.195a.621.621 0 01.11-.006z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M212.959 171.327l-2.06-1.195c-.03.004-.062.007-.1.013l2.056 1.192a.501.501 0 01.104-.01z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M212.855 171.337l-2.056-1.191c-.035.006-.063.006-.1.015l2.055 1.194a.915.915 0 01.1-.018z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M212.754 171.355l-2.056-1.194a.51.51 0 00-.094.022l2.053 1.191a.95.95 0 01.097-.019z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M212.657 171.374l-2.053-1.19a.776.776 0 00-.094.024l2.05 1.195c.03-.013.066-.02.097-.029z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M212.56 171.403l-2.05-1.195c-.032.01-.063.019-.094.032l2.052 1.194a.81.81 0 01.091-.031z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M212.468 171.434l-2.052-1.194c-.032.009-.063.022-.095.031l2.05 1.194c.038-.009.066-.025.097-.031z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M212.37 171.465l-2.049-1.194c-.031.012-.063.031-.094.044l2.056 1.188.088-.038z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M212.283 171.503l-2.056-1.188c-.032.013-.063.028-.094.044l2.05 1.195c.037-.02.065-.032.1-.05z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M212.182 171.554l-2.05-1.195a1.225 1.225 0 00-.094.05l2.05 1.195c.034-.02.062-.035.094-.05z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M212.088 171.604l-2.05-1.195a.445.445 0 00-.075.041l2.05 1.192c.025-.013.056-.026.075-.038z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-11)">
                    <path
                        fill="#c6c7ca"
                        d="M212.012 171.642l-2.05-1.192a.172.172 0 01-.024.013l2.056 1.194c.006-.006.015-.009.018-.015z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M211.994 171.657l-2.056-1.194c-.032.022-.063.037-.1.06l2.055 1.194c.034-.019.069-.04.1-.06z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M211.893 171.717l-2.056-1.195c-.031.02-.063.044-.094.066l2.05 1.195c.034-.022.065-.047.1-.066z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M211.792 171.783l-2.049-1.195a1.157 1.157 0 00-.104.073l2.052 1.191a1.149 1.149 0 00.101-.07z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M211.691 171.852l-2.052-1.191c-.035.025-.066.05-.104.075l2.056 1.195c.032-.026.07-.05.1-.079z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M211.591 171.93l-2.056-1.194c-.031.032-.07.057-.1.088l2.053 1.195c.034-.032.066-.057.103-.088z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M211.488 172.019l-2.053-1.195c-.038.032-.073.057-.107.088l2.055 1.195c.032-.031.07-.06.105-.088z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M211.383 172.107l-2.055-1.195c-.032.032-.07.063-.1.094l2.052 1.195c.034-.031.072-.063.103-.094z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M211.28 172.201l-2.053-1.195-.094.101 2.05 1.192c.037-.035.063-.066.097-.098z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M211.182 172.299l-2.05-1.192a.97.97 0 00-.093.1l2.049 1.192c.035-.035.063-.066.094-.1z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M211.088 172.4l-2.05-1.192a.893.893 0 00-.09.094l2.052 1.195c.032-.032.06-.067.088-.098z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M211 172.497l-2.052-1.195c-.032.038-.06.072-.092.107l2.05 1.194c.031-.034.063-.069.094-.106z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M210.906 172.603l-2.05-1.194-.088.11 2.053 1.191a1.324 1.324 0 00.085-.107z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M210.82 172.71l-2.052-1.191-.104.135 2.056 1.191c.035-.044.067-.087.1-.135z"
                    />
                    <path
                        fill="#fafafd"
                        d="M210.72 172.845l-2.056-1.191c-.05.07-.097.135-.147.208l2.055 1.194a2.507 2.507 0 01.148-.21z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M210.573 173.056l-2.056-1.194a9.249 9.249 0 00-.17.27l2.056 1.194a3.036 3.036 0 01.17-.27z"
                    />
                    <path
                        fill="#fafafd"
                        d="M210.403 173.326l-2.056-1.194c-.037.07-.075.135-.113.201l2.052 1.194c.038-.068.08-.135.117-.2z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M210.286 173.527l-2.052-1.194c-.025.05-.05.094-.07.139l2.05 1.194c.025-.044.05-.091.072-.139zM210.214 173.666l-2.05-1.194a1.077 1.077 0 01-.062.119l2.056 1.2c.018-.043.037-.081.056-.125zM210.158 173.792l-2.056-1.201c-.016.04-.032.075-.044.113l2.05 1.195a.81.81 0 01.05-.107z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M210.107 173.899l-2.05-1.195-.05.113 2.056 1.195c.013-.038.032-.076.044-.113z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M210.063 174.012l-2.055-1.195a.852.852 0 00-.045.114l2.05 1.194a.882.882 0 01.05-.113z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M210.013 174.125l-2.05-1.194a1.696 1.696 0 00-.043.112l2.049 1.192a.913.913 0 00.044-.11z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M209.969 174.235l-2.05-1.192c-.015.038-.025.08-.043.117l2.056 1.191c.012-.037.028-.075.037-.116z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M209.932 174.351l-2.056-1.191c-.013.04-.022.078-.038.12l2.056 1.19c.012-.037.022-.075.038-.119z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M209.894 174.47l-2.056-1.19a.955.955 0 01-.038.122l2.056 1.195.038-.126z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M209.856 174.597l-2.056-1.195a1.066 1.066 0 01-.031.123l2.056 1.19c.012-.037.019-.081.03-.118z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M209.825 174.716l-2.056-1.191c-.007.04-.02.078-.025.122l2.055 1.194a.853.853 0 01.026-.125z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M209.8 174.841l-2.056-1.194a.804.804 0 00-.026.12l2.056 1.194a.785.785 0 01.025-.12z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M209.774 174.96l-2.056-1.193-.019.12 2.053 1.19c.01-.04.01-.078.022-.116z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M209.752 175.077l-2.053-1.19-.018.112 2.055 1.194c.007-.037.01-.075.016-.116z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M209.736 175.193L207.681 174c0 .04-.01.079-.013.117l2.053 1.191c.003-.035.01-.076.015-.114z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M209.72 175.307l-2.052-1.191a.754.754 0 00-.006.116l2.05 1.191.009-.116z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M209.711 175.423l-2.049-1.191a1.214 1.214 0 00-.007.113l2.053 1.194c.003-.04.003-.078.003-.116z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M209.708 175.54l-2.053-1.195-.002.104v.003l2.052 1.194v-.003c0-.035.003-.072.003-.104z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M209.705 175.646l-2.052-1.194.002.107 2.056 1.194a1.116 1.116 0 01-.006-.107z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M209.711 175.753l-2.056-1.194c.004.038.007.072.007.107l2.053 1.194c-.004-.035-.004-.069-.004-.107z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M209.715 175.86l-2.053-1.194a1 1 0 00.01.103l2.052 1.195c-.003-.035-.006-.073-.01-.104z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M209.724 175.964l-2.053-1.195c.01.038.01.072.016.11l2.056 1.188c-.007-.031-.013-.069-.019-.103z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M209.743 176.067l-2.056-1.188a1.012 1.012 0 00.025.107l2.05 1.195-.019-.114z"
                    />
                    <path
                        fill="#959598"
                        d="M209.762 176.18l-2.05-1.194c.006.038.02.076.025.113l2.06 1.195c-.017-.038-.023-.075-.035-.113z"
                    />
                    <path
                        fill="#909093"
                        d="M209.796 176.294l-2.059-1.195c.013.044.028.085.044.126l2.056 1.192a.552.552 0 01-.04-.123z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M209.837 176.417l-2.056-1.192c.016.047.038.094.057.138l2.056 1.192c-.02-.044-.042-.092-.057-.138z"
                    />
                    <path
                        fill="#868689"
                        d="M209.894 176.555l-2.056-1.192q.047.09.094.17l2.056 1.195a1.643 1.643 0 01-.094-.173z"
                    />
                    <path
                        fill="#818184"
                        d="M209.988 176.728l-2.056-1.195c.019.025.035.05.05.075l2.056 1.195a.546.546 0 01-.05-.075z"
                    />
                </g>
                <path
                    fill="#f8f9fd"
                    d="M212.012 171.642a5.087 5.087 0 00-2.307 3.998 1.965 1.965 0 00.333 1.163 12.128 12.128 0 00-2.294 5.775l8.594-4.964c-.249-1.804-1.126-2.936-2.32-3.112a4.325 4.325 0 00.32-1.534c0-1.478-1.04-2.068-2.326-1.326z"
                />
                <path
                    fill="#e53399"
                    d="M202.3 179.51c.002-.123.005-.249.015-.374.01-.126.015-.252.028-.375.013-.126.028-.251.044-.374.019-.132.035-.26.057-.39.018-.131.04-.257.063-.39.028-.131.056-.266.081-.402.035-.131.063-.27.094-.402.035-.138.076-.27.114-.408.025-.107.056-.214.088-.32 0-.008.006-.008.006-.014a4.07 4.07 0 01.019-.072 8.89 8.89 0 01.132-.4c.038-.131.088-.263.132-.392.047-.126.094-.252.138-.377.054-.123.104-.249.157-.371.038-.098.079-.192.123-.29l.003-.009c.006-.022.02-.044.025-.07.063-.125.117-.247.176-.37.06-.135.126-.27.195-.406.076-.154.154-.304.236-.462.088-.16.18-.32.274-.484.015-.028.03-.06.05-.088.019-.031.038-.069.057-.1.182-.315.373-.616.571-.918.158-.233.321-.465.485-.692.113-.15.226-.298.342-.446.098-.123.195-.246.299-.365.094-.12.195-.232.295-.346.095-.11.198-.223.296-.33a.307.307 0 01.056-.053.147.147 0 01.032-.034c.075-.08.15-.164.226-.243a29.863 29.863 0 01.66-.635c.113-.1.233-.201.346-.295.05-.05.11-.091.167-.138a.238.238 0 01.044-.035l.128-.107c.11-.088.224-.173.337-.255.11-.084.22-.163.333-.238.11-.076.217-.145.324-.214.11-.07.22-.139.327-.201a.454.454 0 01.075-.045c.082-.043.164-.094.245-.138.104-.056.208-.106.315-.163l.207-.095a.537.537 0 01.041-.018.986.986 0 01.06-.032c.104-.047.207-.088.308-.132l.311-.113c.016-.006.038-.012.054-.019.012-.006.03-.006.037-.012.076-.025.148-.047.214-.07.107-.03.214-.063.32-.088.05-.015.101-.021.151-.034.023-.003.045-.01.07-.016l.094-.019c.113-.022.223-.04.333-.056.072-.01.139-.013.205-.02a.522.522 0 01.072-.009l.07-.002a3.379 3.379 0 01.357-.013c.057 0 .1.003.154.003.041.003.082.003.123.01.037 0 .082 0 .12.002a4.134 4.134 0 01.446.067h.006a.69.69 0 01.107.03 2.976 2.976 0 01.421.117.25.25 0 01.032.013 4.21 4.21 0 01.59.273l2.057 1.195a3.653 3.653 0 00-.592-.27 3.281 3.281 0 00-.452-.133.798.798 0 00-.113-.031 4.197 4.197 0 00-.573-.075c-.037 0-.078 0-.116-.004a5.352 5.352 0 00-.588.01.41.41 0 01-.066.006 7.027 7.027 0 00-.638.1.251.251 0 01-.069.013 7.04 7.04 0 00-.673.189.496.496 0 01-.05.019 7.193 7.193 0 00-.723.295l-.054.02c-.248.115-.499.247-.757.395a11.57 11.57 0 00-1.534 1.063c-.01.006-.019.015-.031.025a14.212 14.212 0 00-1.409 1.32.094.094 0 00-.025.025 17.915 17.915 0 00-2.404 3.256c-.016.029-.035.057-.05.089a18.257 18.257 0 00-.903 1.785.024.024 0 00-.006.019 18.81 18.81 0 00-.701 1.892.075.075 0 01-.007.022 14.907 14.907 0 00-.44 1.905 12.323 12.323 0 00-.147 1.873c0 .29.016.57.037.84a.304.304 0 01.007.075c.025.252.063.49.107.723a.62.62 0 01.015.08c.048.222.104.436.167.64.012.041.028.079.037.12.064.185.133.358.208.525.013.028.025.056.034.082a5.056 5.056 0 00.3.546 4.347 4.347 0 00.537.667c.044.044.09.088.141.132a4.008 4.008 0 00.648.496l-2.05-1.194a3.307 3.307 0 01-.65-.497q-.076-.066-.142-.132a4.206 4.206 0 01-.534-.66c0-.006-.007-.006-.013-.012-.1-.164-.195-.34-.286-.526-.003-.003-.003-.009-.003-.015a.37.37 0 01-.029-.06 5.323 5.323 0 01-.15-.361c-.022-.063-.04-.126-.067-.19a.81.81 0 01-.03-.11c-.013-.034-.029-.071-.038-.106-.038-.123-.07-.254-.101-.387-.012-.05-.019-.1-.031-.144l-.02-.098c-.005-.047-.018-.09-.024-.138-.026-.12-.041-.242-.057-.364-.006-.073-.016-.142-.022-.217a.365.365 0 00-.01-.063.789.789 0 00-.006-.092 6.182 6.182 0 01-.022-.361 7.177 7.177 0 01-.009-.371v-.022c0-.116 0-.232.006-.346z"
                />
                <path
                    fill="#ff4caa"
                    d="M219.714 172.176a16.883 16.883 0 01-7.664 13.265c-4.237 2.449-7.692.481-7.702-4.391a16.87 16.87 0 017.658-13.275c4.237-2.445 7.692-.484 7.708 4.4zm-3.376 5.438c-.249-1.804-1.126-2.936-2.32-3.112a4.325 4.325 0 00.32-1.534c0-1.478-1.04-2.068-2.326-1.326a5.087 5.087 0 00-2.307 3.998 1.965 1.965 0 00.333 1.163 12.128 12.128 0 00-2.294 5.775l8.594-4.964z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-12)">
                    <path
                        fill="#852858"
                        d="M171.575 235.164l-2.056-1.194a2.615 2.615 0 01.893.886l2.056 1.198a2.677 2.677 0 00-.893-.89z"
                    />
                    <path
                        fill="#8a295c"
                        d="M172.468 236.054l-2.056-1.198a4.352 4.352 0 01.22.4l2.053 1.19a3.112 3.112 0 00-.217-.392z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M172.685 236.447l-2.053-1.192a3.01 3.01 0 01.148.353l2.056 1.194a5.236 5.236 0 00-.151-.355z"
                    />
                    <path
                        fill="#942c63"
                        d="M172.836 236.802l-2.056-1.194c.038.106.075.217.11.333l2.052 1.191c-.034-.113-.072-.223-.106-.33z"
                    />
                    <path
                        fill="#992e66"
                        d="M172.942 237.132l-2.052-1.191a3.256 3.256 0 01.081.323l2.056 1.192a3.647 3.647 0 00-.085-.324z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M173.027 237.456l-2.056-1.192c.026.101.048.211.067.318l2.052 1.191a8.085 8.085 0 00-.063-.317z"
                    />
                    <path
                        fill="#a3316d"
                        d="M173.09 237.773l-2.052-1.191c.009.078.022.154.037.236l2.05 1.194a4.716 4.716 0 00-.035-.239z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-13)">
                    <path
                        fill="#818184"
                        d="M171.575 235.164l-2.056-1.194a1.965 1.965 0 00-.37-.17l2.055 1.194a2.084 2.084 0 01.37.17z"
                    />
                    <path
                        fill="#868689"
                        d="M171.204 234.994l-2.056-1.194a1.797 1.797 0 00-.292-.082l2.052 1.195a2.37 2.37 0 01.296.081z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M170.908 234.913l-2.052-1.195a.939.939 0 00-.1-.016l2.052 1.192.1.019z"
                    />
                </g>
                <g clipPath="url(#clip-path-14)">
                    <path
                        fill="#b8377a"
                        d="M171.129 233.354l-2.05-1.192v.003c0 .038-.006.066-.006.101l2.056 1.194v-.106z"
                    />
                </g>
                <path
                    fill="#dc4193"
                    d="M173.125 238.012L171.075 236.818 162.478 241.778 164.534 242.973 173.125 238.012z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-15)">
                    <path
                        fill="#852858"
                        d="M170.456 231.87l-2.056-1.192a1.176 1.176 0 01.4.387l2.052 1.198a1.187 1.187 0 00-.396-.393z"
                    />
                    <path
                        fill="#8a295c"
                        d="M170.852 232.263l-2.053-1.198c.032.053.06.107.092.16l2.05 1.195a.845.845 0 00-.089-.157z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M170.94 232.42l-2.05-1.195c.02.041.035.085.054.133l2.053 1.19c-.02-.043-.035-.084-.057-.128z"
                    />
                    <path
                        fill="#942c63"
                        d="M170.997 232.549l-2.053-1.191c.016.04.025.081.041.122l2.053 1.195c-.01-.044-.029-.085-.041-.126z"
                    />
                    <path
                        fill="#992e66"
                        d="M171.038 232.675l-2.053-1.195c.013.038.019.082.028.12l2.053 1.191a1.188 1.188 0 00-.028-.116z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M171.066 232.791l-2.053-1.191c.01.037.016.075.025.113l2.053 1.194a.752.752 0 00-.025-.116z"
                    />
                    <path
                        fill="#a3316d"
                        d="M171.091 232.907l-2.053-1.194.016.113 2.056 1.194a2.315 2.315 0 00-.019-.113z"
                    />
                    <path
                        fill="#a83270"
                        d="M171.11 233.02l-2.056-1.194a1.08 1.08 0 01.012.113l2.056 1.191c-.006-.04-.009-.078-.012-.11z"
                    />
                    <path
                        fill="#ad3474"
                        d="M171.122 233.13l-2.056-1.191c0 .035.007.076.007.107l2.056 1.194c0-.037-.007-.075-.007-.11z"
                    />
                    <path
                        fill="#b33577"
                        d="M171.129 233.24l-2.056-1.194a.7.7 0 00.006.116l2.05 1.192v-.114z"
                    />
                    <path
                        fill="#b8377a"
                        d="M171.129 233.354l-2.05-1.192v.003c0 .038-.006.066-.006.101l2.056 1.194v-.106z"
                    />
                    <path
                        fill="#bd387e"
                        d="M171.129 233.46l-2.056-1.194a.644.644 0 01-.007.11l2.056 1.191a.602.602 0 00.007-.107z"
                    />
                    <path
                        fill="#c23a81"
                        d="M171.122 233.567l-2.056-1.19c0 .034-.003.068-.003.106l2.053 1.191c0-.037.006-.075.006-.107z"
                    />
                    <path
                        fill="#c73b85"
                        d="M171.116 233.674l-2.053-1.191a.927.927 0 00-.015.107l2.056 1.191a.578.578 0 01.012-.107z"
                    />
                    <path
                        fill="#cc3d88"
                        d="M171.104 233.781l-2.056-1.191a.73.73 0 01-.02.11l2.057 1.191c.006-.035.013-.069.019-.11z"
                    />
                    <path
                        fill="#d13e8b"
                        d="M171.085 233.891l-2.056-1.191a.502.502 0 01-.016.116l2.053 1.195c.01-.041.012-.079.019-.12z"
                    />
                    <path
                        fill="#d6408f"
                        d="M171.066 234.01l-2.053-1.194c-.01.038-.015.079-.028.12l2.059 1.19c.003-.04.016-.081.022-.115z"
                    />
                    <path
                        fill="#db4192"
                        d="M171.044 234.127l-2.059-1.191c-.006.037-.016.075-.025.119l2.052 1.198c.01-.044.022-.089.032-.126z"
                    />
                    <path
                        fill="#e04396"
                        d="M171.012 234.253l-2.052-1.198c-.013.04-.019.085-.032.129l2.053 1.188c.013-.04.022-.082.031-.12z"
                    />
                    <path
                        fill="#e64499"
                        d="M170.98 234.372l-2.052-1.188-.037.126 2.053 1.194c.009-.044.025-.088.037-.132z"
                    />
                    <path
                        fill="#eb469c"
                        d="M170.944 234.504l-2.053-1.194a1.828 1.828 0 01-.045.131l2.056 1.192c.013-.047.025-.085.042-.13z"
                    />
                    <path
                        fill="#f047a0"
                        d="M170.902 234.633l-2.056-1.192c-.015.045-.028.089-.044.13l2.053 1.194c.016-.047.032-.085.047-.132z"
                    />
                    <path
                        fill="#f549a3"
                        d="M170.855 234.765l-2.053-1.194a3.927 3.927 0 00-.047.131l2.053 1.192c.02-.044.031-.082.047-.129z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-16)">
                    <path
                        fill="#f9fafd"
                        d="M166.828 237.195L164.773 236l-.095.126 2.056 1.191a.946.946 0 01.094-.122z"
                    />
                    <path
                        fill="#fafafd"
                        d="M166.734 237.317l-2.056-1.191c-.078.107-.157.22-.232.333l2.052 1.189c.079-.114.154-.22.236-.33z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M166.498 237.648l-2.052-1.189c-.132.195-.267.4-.39.61l2.056 1.195c.122-.21.251-.415.386-.616z"
                    />
                    <path
                        fill="#fafafd"
                        d="M166.112 238.264l-2.056-1.195c-.075.132-.151.27-.226.409l2.056 1.191c.072-.138.144-.27.226-.405z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M165.886 238.669l-2.056-1.191c-.05.094-.098.188-.145.286l2.05 1.198q.075-.151.15-.293z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M165.735 238.962l-2.05-1.198-.129.26 2.053 1.195c.044-.091.088-.175.126-.257zM165.609 239.22l-2.053-1.195-.11.251 2.05 1.195c.037-.088.075-.17.113-.252z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M165.496 239.47l-2.05-1.194c-.038.085-.078.17-.113.255l2.056 1.194c.031-.085.07-.17.107-.254z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M165.389 239.726l-2.056-1.195c-.038.088-.07.179-.107.267l2.056 1.188c.034-.085.07-.173.107-.26z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M165.282 239.986l-2.056-1.188c-.031.088-.07.182-.103.277l2.055 1.188c.035-.088.066-.183.104-.277z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M165.178 240.263l-2.055-1.188c-.035.094-.067.192-.105.289l2.056 1.194c.032-.097.063-.195.104-.295z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M165.074 240.558l-2.056-1.194c-.03.1-.065.207-.094.308l2.05 1.194c.031-.1.069-.207.1-.308z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M164.974 240.866l-2.05-1.194a4.15 4.15 0 00-.094.32l2.056 1.195c.025-.107.057-.214.088-.32z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M164.886 241.187l-2.056-1.194c-.031.11-.056.217-.085.326l2.053 1.195c.028-.113.053-.22.088-.327z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M164.798 241.514l-2.053-1.195c-.028.107-.053.22-.078.33l2.05 1.195c.024-.11.056-.223.081-.33z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M164.716 241.844l-2.05-1.194c-.024.116-.05.217-.069.333l2.056 1.191c.02-.11.044-.22.063-.33z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M164.653 242.174l-2.056-1.191-.056.33 2.056 1.194c.012-.113.034-.22.056-.333z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M164.597 242.507l-2.056-1.194c-.02.107-.032.217-.044.327l2.052 1.194c.01-.113.029-.22.048-.327z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M164.55 242.834l-2.053-1.194c-.006.044-.016.094-.019.138l2.056 1.195c.006-.05.006-.095.015-.139z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-17)">
                    <path
                        fill="#818184"
                        d="M170.456 231.87l-2.056-1.192a1.24 1.24 0 00-.182-.087l2.053 1.197a1.664 1.664 0 01.185.082z"
                    />
                    <path
                        fill="#868689"
                        d="M170.27 231.788l-2.052-1.197a.961.961 0 00-.164-.041l2.056 1.194a.754.754 0 01.16.044z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M170.11 231.744l-2.056-1.194a.485.485 0 00-.132-.02l2.053 1.192a.647.647 0 01.135.022z"
                    />
                    <path
                        fill="#909093"
                        d="M169.975 231.722l-2.052-1.191a.755.755 0 00-.12-.006l2.05 1.19a.795.795 0 01.122.007z"
                    />
                    <path
                        fill="#959598"
                        d="M169.853 231.716l-2.05-1.191h-.11l2.056 1.194c.034-.003.072-.003.104-.003z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M169.749 231.72l-2.056-1.195c-.035.006-.066.006-.104.012l2.053 1.195c.038-.007.072-.01.107-.013z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M169.642 231.732l-2.053-1.195a.97.97 0 01-.1.016l2.056 1.194c.03-.006.062-.01.097-.015z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M169.545 231.747l-2.056-1.194c-.032.003-.06.015-.095.022l2.056 1.194a.459.459 0 01.094-.022z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M169.45 231.77l-2.056-1.195c-.031.01-.062.016-.097.025l2.053 1.194c.03-.006.065-.019.1-.025z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M169.35 231.794l-2.053-1.194a.727.727 0 00-.091.034l2.05 1.192a.593.593 0 01.094-.032z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M169.255 231.826l-2.05-1.192c-.03.01-.062.023-.094.035l2.05 1.195a.409.409 0 01.094-.038z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M169.16 231.864l-2.049-1.195c-.031.01-.062.025-.094.038l2.05 1.191c.03-.013.066-.022.094-.034z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M169.066 231.898l-2.05-1.191a1.398 1.398 0 00-.093.044l2.052 1.194a.755.755 0 00.091-.047z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M168.975 231.945l-2.052-1.194a.881.881 0 00-.095.05l2.05 1.195c.031-.02.066-.035.097-.05z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M168.878 231.996l-2.05-1.195a.83.83 0 00-.075.041l2.053 1.194a.783.783 0 01.072-.04z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-18)">
                    <path
                        fill="#c6c7ca"
                        d="M168.806 232.036l-2.053-1.194a.1.1 0 00-.025.016l2.053 1.194c.01-.01.015-.01.025-.016z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M168.78 232.052l-2.052-1.194a3.779 3.779 0 01-.1.056l2.055 1.195c.035-.02.07-.038.098-.057z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M168.683 232.109l-2.056-1.195c-.031.025-.066.044-.097.07l2.053 1.19c.034-.021.069-.043.1-.065z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M168.583 232.175l-2.053-1.192c-.035.023-.066.048-.1.073l2.055 1.191c.031-.025.066-.05.098-.072z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M168.485 232.247l-2.056-1.191c-.034.022-.066.047-.103.075l2.056 1.198a.796.796 0 01.103-.082z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M168.381 232.329l-2.056-1.198c-.03.028-.069.06-.1.085l2.05 1.195c.037-.032.072-.057.107-.082z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M168.275 232.41l-2.05-1.194c-.038.028-.07.063-.104.091l2.053 1.191c.034-.028.066-.056.1-.087z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M168.174 232.498l-2.053-1.191c-.034.035-.066.063-.104.098l2.056 1.19.1-.097z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M168.073 232.596l-2.056-1.191-.094.094 2.05 1.191a.975.975 0 01.1-.094z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M167.973 232.69l-2.05-1.191a.984.984 0 00-.097.1l2.055 1.192c.029-.035.06-.066.092-.1z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M167.881 232.791l-2.055-1.191c-.032.03-.06.063-.091.094l2.056 1.194c.028-.031.06-.062.09-.097z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.79 232.888l-2.055-1.194a1.012 1.012 0 01-.088.107l2.055 1.191c.026-.035.057-.066.089-.104z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.702 232.992l-2.055-1.191c-.026.037-.063.075-.089.113l2.056 1.188c.025-.031.057-.069.088-.11zM167.614 233.102l-2.056-1.188-.103.132 2.053 1.194.106-.138z"
                    />
                    <path
                        fill="#fafafd"
                        d="M167.508 233.24l-2.053-1.194-.148.207 2.056 1.195c.044-.07.094-.142.145-.208z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M167.363 233.448l-2.056-1.195c-.056.091-.113.18-.17.27l2.056 1.195c.05-.091.11-.182.17-.27z"
                    />
                    <path
                        fill="#fafafd"
                        d="M167.193 233.718l-2.056-1.194c-.038.069-.075.138-.113.201l2.056 1.2c.035-.072.075-.138.113-.207z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.08 233.926l-2.056-1.201c-.025.05-.05.094-.072.145l2.053 1.194c.025-.05.05-.094.075-.138z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.005 234.064l-2.053-1.194c-.022.037-.038.075-.06.12l2.056 1.19.057-.116z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M166.948 234.18l-2.056-1.19a.857.857 0 00-.044.106l2.05 1.194c.012-.031.031-.072.05-.11z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M166.898 234.29l-2.05-1.194c-.019.044-.038.075-.05.11l2.053 1.197.047-.113z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M166.85 234.403l-2.052-1.197a.993.993 0 00-.044.116l2.05 1.195.047-.114z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M166.803 234.517l-2.05-1.195a.763.763 0 00-.043.113l2.052 1.195c.016-.044.029-.076.041-.113z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M166.762 234.63l-2.052-1.195c-.013.038-.032.076-.044.12l2.055 1.188c.013-.034.029-.075.041-.113z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M166.721 234.743l-2.055-1.188c-.013.038-.022.075-.038.12l2.056 1.19c.012-.04.025-.078.037-.122z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M166.684 234.865l-2.056-1.19c-.013.037-.022.081-.035.119l2.053 1.194.038-.123z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M166.646 234.988l-2.053-1.194c-.012.044-.021.081-.034.122l2.056 1.191c.01-.037.022-.078.031-.119z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M166.615 235.107l-2.056-1.19c-.006.04-.019.078-.025.122l2.052 1.194c.01-.044.016-.081.029-.126z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M166.586 235.233l-2.052-1.194c-.01.038-.02.082-.025.12l2.052 1.194c.01-.038.016-.079.025-.12z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M166.561 235.353l-2.052-1.195c-.006.038-.016.082-.02.12l2.057 1.194a.814.814 0 01.015-.12z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M166.546 235.472l-2.056-1.194a4.3 4.3 0 01-.02.113l2.057 1.2a.706.706 0 01.019-.119z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M166.527 235.592l-2.056-1.201a1.054 1.054 0 01-.013.116l2.05 1.195c.006-.035.012-.076.019-.11z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M166.508 235.702l-2.05-1.195c-.003.041-.006.076-.006.116l2.052 1.195c0-.04.004-.075.004-.116z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M166.504 235.818l-2.052-1.195a.679.679 0 00-.006.114l2.052 1.191c.004-.035.004-.075.006-.11z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M166.498 235.928l-2.052-1.191v.11l2.05 1.197v-.009l.002-.107z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M166.495 236.044l-2.05-1.194v.1l2.057 1.198a1.141 1.141 0 01-.007-.104z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M166.502 236.148l-2.056-1.197c0 .037.006.075.006.106l2.052 1.195-.002-.104z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M166.504 236.252l-2.052-1.195a.76.76 0 00.013.104l2.05 1.198c-.007-.038-.007-.072-.01-.107z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M166.514 236.359l-2.05-1.198c.004.041.01.072.013.11l2.056 1.195a1.02 1.02 0 00-.019-.107z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M166.533 236.466l-2.056-1.195a1.018 1.018 0 00.026.107l2.049 1.195a7.062 7.062 0 00-.02-.107z"
                    />
                    <path
                        fill="#959598"
                        d="M166.552 236.573l-2.05-1.195c.007.038.02.079.026.116l2.056 1.191c-.007-.037-.023-.072-.032-.112z"
                    />
                    <path
                        fill="#909093"
                        d="M166.584 236.685l-2.056-1.19c.012.04.028.08.044.122l2.052 1.194a1.824 1.824 0 01-.04-.126z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M166.624 236.811l-2.052-1.194c.018.05.037.094.056.138l2.056 1.191c-.022-.044-.041-.09-.06-.135z"
                    />
                    <path
                        fill="#868689"
                        d="M166.684 236.946l-2.056-1.19c.031.062.063.119.094.172l2.056 1.191a1.504 1.504 0 01-.094-.173z"
                    />
                    <path
                        fill="#818184"
                        d="M166.778 237.12l-2.056-1.192c.02.022.032.047.05.072l2.056 1.195a.546.546 0 01-.05-.076z"
                    />
                </g>
                <path
                    fill="#f8f9fd"
                    d="M168.806 232.036a5.078 5.078 0 00-2.31 4 1.956 1.956 0 00.332 1.159 12.126 12.126 0 00-2.294 5.778l8.59-4.961c-.248-1.81-1.121-2.942-2.316-3.118a4.332 4.332 0 00.32-1.534c0-1.475-1.043-2.069-2.322-1.324z"
                />
                <path
                    fill="#e1bb00"
                    d="M159.09 239.901c.006-.122.006-.248.012-.374.013-.125.019-.248.031-.377.013-.123.028-.251.044-.374q.024-.193.057-.387c.019-.129.041-.257.063-.39.031-.132.056-.263.085-.402.028-.132.06-.264.09-.4.032-.137.073-.276.111-.41.028-.108.06-.214.091-.321a.018.018 0 00.006-.013.58.58 0 00.02-.072c.043-.136.087-.267.125-.4.047-.128.094-.257.138-.39.047-.125.094-.25.144-.376.048-.126.101-.252.148-.378.041-.094.085-.189.126-.289l.004-.003.028-.072c.06-.126.113-.248.173-.371.062-.135.125-.27.194-.403.076-.157.158-.308.24-.462.087-.166.175-.323.27-.487.015-.025.031-.053.05-.082l.056-.106a19.5 19.5 0 01.573-.918 18.127 18.127 0 01.826-1.135c.098-.123.195-.245.3-.368.093-.12.194-.23.295-.346.097-.113.194-.22.295-.333a.645.645 0 01.057-.05.164.164 0 01.031-.035l.23-.242c.106-.107.21-.214.323-.32a10.73 10.73 0 01.68-.61c.053-.044.11-.092.163-.139a.265.265 0 00.044-.034c.044-.035.088-.072.132-.104.11-.091.226-.176.336-.26.11-.08.223-.155.333-.234.11-.078.217-.147.327-.217.107-.069.217-.137.324-.2.025-.013.05-.026.075-.042.082-.047.167-.094.246-.137l.314-.167.204-.094.041-.02c.022-.012.044-.018.063-.03.107-.045.208-.089.308-.127.107-.047.208-.082.311-.12l.054-.015c.012-.01.031-.01.044-.016a1.656 1.656 0 01.21-.066c.104-.034.21-.062.318-.09.05-.01.1-.023.15-.032a.443.443 0 01.063-.016l.101-.022c.113-.022.227-.038.333-.056l.205-.02a.583.583 0 01.072-.006.267.267 0 01.069-.006 3.394 3.394 0 01.359-.012c.053 0 .1.003.154.006.04.003.081.003.122.006a.836.836 0 01.123.006 4.182 4.182 0 01.443.063h.006a.806.806 0 00.107.032 3.741 3.741 0 01.424.119.11.11 0 01.029.01 4.232 4.232 0 01.59.273l2.056 1.198a3.356 3.356 0 00-.59-.274 3.502 3.502 0 00-.453-.132c-.038-.012-.075-.022-.113-.031a4.221 4.221 0 00-.57-.07.772.772 0 00-.122-.006 4.105 4.105 0 00-.584.013.402.402 0 00-.063.006 5.903 5.903 0 00-.642.095.424.424 0 01-.07.015 6.484 6.484 0 00-.671.192.174.174 0 00-.048.016 7.88 7.88 0 00-.732.289.318.318 0 01-.044.022 8.793 8.793 0 00-.76.396 11.572 11.572 0 00-1.535 1.062.114.114 0 01-.031.025 15.064 15.064 0 00-1.409 1.321.242.242 0 00-.028.025 18.04 18.04 0 00-2.405 3.263c-.012.025-.03.053-.044.082a18.256 18.256 0 00-.905 1.788l-.01.016a16.37 16.37 0 00-.694 1.892c0 .007-.006.013-.006.025a14.33 14.33 0 00-.443 1.905 12.279 12.279 0 00-.152 1.87c.004.293.016.57.042.84.003.025.003.053.006.075.025.252.063.49.106.72a.6.6 0 01.016.085 6.622 6.622 0 00.167.641c.013.038.028.08.038.12.062.182.129.358.204.525.016.028.025.053.041.078a3.564 3.564 0 00.301.55 4.455 4.455 0 00.529.664c.05.044.094.088.144.135a3.74 3.74 0 00.648.493l-2.05-1.194a3.503 3.503 0 01-.654-.49 5.124 5.124 0 00-.141-.139 4.28 4.28 0 01-.532-.66l-.009-.012a4.714 4.714 0 01-.286-.522c-.006-.007-.006-.013-.012-.019-.007-.019-.013-.044-.019-.063a4.958 4.958 0 01-.154-.352c-.022-.066-.041-.132-.066-.198-.013-.035-.022-.072-.031-.104-.016-.038-.026-.072-.038-.107a6.943 6.943 0 01-.1-.39c-.014-.05-.02-.094-.033-.144l-.018-.1c-.007-.045-.019-.086-.026-.133-.025-.12-.037-.242-.056-.37-.006-.067-.016-.139-.022-.208a.435.435 0 00-.01-.07c0-.03-.005-.059-.005-.087a3.34 3.34 0 01-.02-.365c-.009-.12-.009-.245-.012-.37v-.023c0-.116.003-.23.006-.346z"
                />
                <path
                    fill="#ffdf02"
                    d="M176.504 232.57a16.901 16.901 0 01-7.657 13.266c-4.244 2.446-7.695.481-7.711-4.394a16.878 16.878 0 017.66-13.275c4.238-2.449 7.692-.481 7.708 4.404zm-3.38 5.442c-.248-1.81-1.121-2.942-2.316-3.118a4.332 4.332 0 00.32-1.534c0-1.475-1.043-2.069-2.322-1.324a5.078 5.078 0 00-2.31 4 1.956 1.956 0 00.332 1.159 12.126 12.126 0 00-2.294 5.778l8.59-4.961z"
                />
                <path
                    fill="#abbec5"
                    d="M238.87 118.228L236.902 117.087 236.905 118.747 238.873 119.888 238.87 118.228z"
                />
                <path
                    fill="#abbec5"
                    d="M238.857 113.928L236.89 112.787 236.893 114.447 238.86 115.588 238.857 113.928z"
                />
                <path
                    fill="#abbec5"
                    d="M238.845 109.42L236.877 108.276 236.883 109.933 238.851 111.077 238.845 109.42z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.873 119.888L236.905 118.747 187.409 147.324 189.38 148.465 238.873 119.888z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.87 118.228L236.902 117.087 187.405 145.664 189.373 146.808 238.87 118.228z"
                />
                <path
                    fill="#3190a4"
                    d="M189.373 146.808L187.405 145.664 187.409 147.324 189.38 148.465 189.373 146.808z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.86 115.588L236.893 114.447 187.399 143.024 189.367 144.168 238.86 115.588z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.857 113.928L236.89 112.787 187.393 141.364 189.361 142.508 238.857 113.928z"
                />
                <path
                    fill="#3190a4"
                    d="M189.361 142.508L187.393 141.364 187.399 143.024 189.367 144.168 189.361 142.508z"
                />
                <path
                    fill="#bfd4dc"
                    d="M238.851 111.077L236.883 109.933 187.387 138.513 189.355 139.654 238.851 111.077z"
                />
                <path
                    fill="#3190a4"
                    d="M189.345 137.997L187.38 136.853 187.387 138.513 189.355 139.654 189.345 137.997z"
                />
                <path
                    fill="#7d3fd4"
                    d="M189.345 137.997L189.355 139.654 238.851 111.077 238.845 109.42 189.345 137.997z"
                />
                <path
                    fill="#36a0b7"
                    d="M238.845 109.42L236.877 108.276 187.38 136.853 189.345 137.997 238.845 109.42z"
                />
                <path
                    fill="#f5d9fc"
                    d="M238.449 105.642c1.823-1.05 3.3-.21 3.307 1.886l.03 10.94a7.223 7.223 0 01-3.287 5.689L197.52 147.82l-10.801 16.276-.088-13.39c-.012-.13-.035-.24-.038-.378l-.028-10.939a7.22 7.22 0 013.291-5.693zm-49.094 34.012l49.496-28.577-.006-1.657-49.5 28.577.01 1.657zm.025 8.81l49.493-28.576-.003-1.66-49.497 28.58.007 1.657zm-.013-4.296l49.493-28.58-.003-1.66-49.496 28.58.006 1.66z"
                />
                <path
                    fill="#7d3fd4"
                    d="M189.373 146.808L189.38 148.465 238.873 119.888 238.87 118.228 189.373 146.808z"
                />
                <path
                    fill="#7d3fd4"
                    d="M189.361 142.508L189.367 144.168 238.86 115.588 238.857 113.928 189.361 142.508z"
                />
                <path
                    fill="#cba9eb"
                    d="M184.601 138.101c0-.057.004-.107.007-.163.003-.054.006-.107.012-.158l.019-.163a1.603 1.603 0 01.025-.167c.007-.053.02-.11.026-.166l.037-.17.038-.173c.019-.06.032-.116.05-.176.01-.047.025-.091.038-.135a.028.028 0 01.003-.016c.003-.006.003-.015.006-.022.019-.056.041-.113.06-.17a1.163 1.163 0 01.057-.17c.019-.05.037-.106.056-.16.019-.053.044-.107.066-.16.016-.044.035-.081.054-.126l.006-.009a.07.07 0 01.01-.022c.021-.054.047-.107.072-.157.025-.06.053-.12.081-.176.035-.063.07-.132.104-.195.035-.076.079-.145.123-.22a.175.175 0 00.012-.029.167.167 0 00.02-.034c.081-.132.163-.267.25-.402l.211-.296.007-.006c.044-.063.094-.126.141-.186.038-.053.082-.103.126-.157.044-.05.082-.1.129-.147.04-.048.084-.098.128-.145a.165.165 0 00.026-.025.072.072 0 00.012-.02c.032-.03.063-.065.095-.094.044-.05.094-.094.138-.138a2.02 2.02 0 01.151-.138 1.89 1.89 0 01.144-.126.678.678 0 01.076-.063l.019-.015c.015-.013.031-.029.05-.041l.148-.113c.047-.035.097-.07.14-.1.052-.033.095-.064.143-.095l.14-.089.032-.018 48.592-28.052c.034-.02.069-.038.103-.057.048-.025.092-.05.136-.069.047-.025.09-.047.135-.066.047-.019.088-.038.129-.056a1.409 1.409 0 01.138-.048c.007-.006.016-.006.019-.01a.032.032 0 01.016-.003.578.578 0 01.097-.03c.044-.016.091-.026.138-.039.041-.012.089-.022.132-.031.047-.006.095-.019.142-.022.034-.006.066-.01.097-.013h.013a.208.208 0 01.037-.002c.057-.004.108-.007.154-.007.06 0 .117.003.173.007a1.208 1.208 0 01.189.03h.01c.078.016.147.038.223.06a1.795 1.795 0 01.264.126c.66.38 1.313.764 1.97 1.141a1.83 1.83 0 00-.49-.182h-.006a1.89 1.89 0 00-.556-.031l-.013.003a2.348 2.348 0 00-.607.135h-.012a3.895 3.895 0 00-.664.308l-48.59 28.055a5.37 5.37 0 00-.654.45l-.023.022a5.536 5.536 0 00-.6.556l-.013.016a7.252 7.252 0 00-.556.666 8.576 8.576 0 00-.48.74.055.055 0 00-.013.018 8.96 8.96 0 00-.396.776v.007a6.53 6.53 0 00-.3.814l-.002.01a5.602 5.602 0 00-.255 1.618l.028 10.94c.003.137.025.248.038.376l.088 13.391-1.968-1.14-.088-13.395a.479.479 0 00-.006-.072c-.006-.041-.006-.076-.012-.113a.7.7 0 01-.013-.088v-.054a.183.183 0 01-.003-.044v-.003l-.029-10.942z"
                />
                <path
                    fill="#abbec5"
                    d="M195.207 104.73L193.114 103.514 193.12 105.277 195.214 106.494 195.207 104.73z"
                />
                <path
                    fill="#abbec5"
                    d="M195.195 100.153L193.101 98.937 193.108 100.7 195.201 101.92 195.195 100.153z"
                />
                <path
                    fill="#abbec5"
                    d="M195.182 95.35L193.089 94.137 193.095 95.9 195.189 97.117 195.182 95.35z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.214 106.494L193.12 105.277 140.436 135.696 142.53 136.913 195.214 106.494z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.207 104.73L193.114 103.514 140.433 133.93 142.523 135.146 195.207 104.73z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.523 135.146L142.53 136.913 195.214 106.494 195.207 104.73 142.523 135.146z"
                />
                <path
                    fill="#3190a4"
                    d="M142.523 135.146L140.433 133.93 140.436 135.696 142.53 136.913 142.523 135.146z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.201 101.92L193.108 100.7 140.424 131.119 142.517 132.336 195.201 101.92z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.195 100.153L193.101 98.937 140.417 129.353 142.511 130.569 195.195 100.153z"
                />
                <path
                    fill="#3190a4"
                    d="M142.511 130.569L140.417 129.353 140.424 131.119 142.517 132.336 142.511 130.569z"
                />
                <path
                    fill="#bfd4dc"
                    d="M195.189 97.117L193.095 95.9 140.411 126.319 142.505 127.533 195.189 97.117z"
                />
                <path
                    fill="#36a0b7"
                    d="M195.182 95.35L193.089 94.137 140.405 124.553 142.498 125.769 195.182 95.35z"
                />
                <path
                    fill="#3190a4"
                    d="M142.498 125.769L140.405 124.553 140.411 126.319 142.505 127.533 142.498 125.769z"
                />
                <path
                    fill="#f5d9fc"
                    d="M194.607 91.421c1.94-1.122 3.518-.23 3.527 2.002l.032 11.644c0 .148-.029.292-.035.443l-.013 14.309-11.552-4.018-43.615 25.18c-1.936 1.119-3.514.226-3.517-2.003l-.035-11.646a7.69 7.69 0 013.499-6.055zm-52.09 40.915l52.684-30.416-.006-1.767-52.684 30.416.006 1.767zm.013 4.577l52.684-30.42-.007-1.763-52.684 30.416.007 1.767zm-.025-9.38l52.684-30.416-.007-1.767-52.684 30.42.007 1.763z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.511 130.569L142.517 132.336 195.201 101.92 195.195 100.153 142.511 130.569z"
                />
                <path
                    fill="#7d3fd4"
                    d="M142.498 125.769L142.505 127.533 195.189 97.117 195.182 95.35 142.498 125.769z"
                />
                <path
                    fill="#cba9eb"
                    d="M137.306 125.958c.006-.053.009-.116.012-.17a1.521 1.521 0 01.013-.173c.003-.056.012-.113.018-.17.007-.06.02-.119.025-.176.01-.056.02-.119.032-.179s.025-.12.035-.182c.015-.06.028-.122.046-.182.013-.063.032-.126.045-.186.016-.05.03-.1.044-.15l.006-.007a.119.119 0 01.006-.031c.016-.057.038-.12.057-.18.019-.06.037-.12.063-.179.025-.056.043-.113.063-.17.025-.056.05-.116.072-.172.015-.047.038-.085.056-.132l.003-.01c.007-.01.007-.019.013-.025l.076-.17c.03-.063.056-.125.088-.182.037-.072.072-.144.11-.214.04-.072.084-.15.125-.22l.022-.044a.34.34 0 00.026-.04 6.23 6.23 0 01.263-.419 5.05 5.05 0 01.22-.317c.05-.07.108-.136.158-.205l.132-.17.138-.156c.044-.05.088-.101.132-.148a.253.253 0 00.029-.029.037.037 0 01.015-.015c.035-.035.07-.072.1-.107l.152-.148c.05-.047.1-.097.154-.145.053-.044.103-.09.154-.135.025-.022.053-.04.078-.06.007-.009.016-.012.022-.018.019-.02.038-.032.057-.048.05-.04.1-.081.154-.116.05-.04.104-.075.154-.113.05-.031.097-.063.148-.094s.097-.063.147-.094a.33.33 0 01.035-.02l51.71-29.856c.037-.018.078-.04.11-.06.05-.028.1-.053.144-.078.05-.019.094-.044.145-.063.05-.025.094-.04.141-.06a1.005 1.005 0 01.141-.053.112.112 0 00.029-.013h.01a1.73 1.73 0 01.1-.034c.05-.016.104-.029.148-.041.053-.013.097-.022.144-.031a1.41 1.41 0 01.155-.026c.034-.006.069-.006.103-.012h.016c.012 0 .022-.003.037-.003a1.499 1.499 0 01.167-.006 1.74 1.74 0 01.18.009q.103.01.207.028l.006.003a1.801 1.801 0 01.233.063 2.407 2.407 0 01.289.132c.626.365 1.257.73 1.88 1.097l.213.12a1.824 1.824 0 00-.521-.195l-.007-.003a2.17 2.17 0 00-.594-.029h-.01a2.897 2.897 0 00-.653.145c-.006 0-.006.003-.01.003a3.913 3.913 0 00-.71.327l-51.71 29.856a5.32 5.32 0 00-.697.481.057.057 0 01-.016.013 7.827 7.827 0 00-.648.603l-.006.01a8.136 8.136 0 00-1.1 1.49l-.019.031c-.154.27-.295.544-.421.824a8.213 8.213 0 00-.314.87c-.007.004-.007.004-.007.007a6.032 6.032 0 00-.27 1.725l.035 11.647a4.283 4.283 0 00.069.751.093.093 0 01.003.025 3.029 3.029 0 00.201.617c0 .006.006.009.006.012a1.903 1.903 0 00.261.403 1.414 1.414 0 00.1.125 1.725 1.725 0 00.381.315l-2.093-1.217a1.787 1.787 0 01-.38-.311c-.036-.038-.067-.082-.099-.123-.043-.053-.09-.1-.131-.16a3.788 3.788 0 01-.13-.239l-.002-.012s0-.004-.007-.007c-.025-.06-.05-.116-.075-.179-.019-.06-.044-.123-.06-.186-.016-.056-.035-.12-.047-.179-.006-.025-.01-.047-.019-.075v-.025a.699.699 0 01-.015-.073 3.175 3.175 0 01-.023-.166 1.547 1.547 0 01-.022-.17c-.003-.053-.009-.107-.009-.167 0-.056-.003-.113-.006-.166v-.01l-.031-11.646z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-19)">
                    <path
                        fill="#852858"
                        d="M214.785 95.658l-2.056-1.194a2.676 2.676 0 01.896.886l2.053 1.195a2.646 2.646 0 00-.893-.887z"
                    />
                    <path
                        fill="#8a295c"
                        d="M215.678 96.545l-2.053-1.195a4.354 4.354 0 01.217.397l2.053 1.194a2.973 2.973 0 00-.217-.396z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M215.895 96.941l-2.053-1.194c.053.112.1.232.15.351l2.05 1.195a3.93 3.93 0 00-.147-.352z"
                    />
                    <path
                        fill="#942c63"
                        d="M216.042 97.293l-2.05-1.195c.039.11.076.22.108.337l2.05 1.191c-.03-.113-.07-.226-.108-.333z"
                    />
                    <path
                        fill="#992e66"
                        d="M216.15 97.626l-2.05-1.191c.031.104.06.21.081.323l2.056 1.195a5.142 5.142 0 00-.088-.327z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M216.237 97.953l-2.056-1.195c.025.101.047.211.067.318l2.052 1.195a4.325 4.325 0 00-.063-.318z"
                    />
                    <path
                        fill="#a3316d"
                        d="M216.3 98.27l-2.052-1.194c.015.076.025.154.034.236l2.056 1.188-.038-.23z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-20)">
                    <path
                        fill="#818184"
                        d="M214.785 95.658l-2.056-1.194a1.908 1.908 0 00-.37-.17l2.055 1.192a2.47 2.47 0 01.371.172z"
                    />
                    <path
                        fill="#868689"
                        d="M214.414 95.486l-2.056-1.192a2.03 2.03 0 00-.29-.082l2.05 1.195a1.848 1.848 0 01.296.079z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M214.118 95.407l-2.05-1.195-.106-.018 2.056 1.194.1.019z"
                    />
                </g>
                <g clipPath="url(#clip-path-21)">
                    <path
                        fill="#b8377a"
                        d="M214.338 93.847l-2.052-1.194v.006c0 .038-.003.07-.003.1l2.055 1.196v-.108z"
                    />
                </g>
                <path
                    fill="#dc4193"
                    d="M216.338 98.5L214.282 97.312 205.688 102.272 207.744 103.467 216.338 98.5z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-22)">
                    <path
                        fill="#852858"
                        d="M213.666 92.364l-2.056-1.191a1.207 1.207 0 01.402.386l2.05 1.195a1.2 1.2 0 00-.396-.39z"
                    />
                    <path
                        fill="#8a295c"
                        d="M214.062 92.754l-2.05-1.195c.032.05.057.104.088.164l2.05 1.191a1.358 1.358 0 00-.088-.16z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M214.15 92.914l-2.05-1.191a1.068 1.068 0 01.05.132l2.056 1.191a2.958 2.958 0 00-.056-.132z"
                    />
                    <path
                        fill="#942c63"
                        d="M214.206 93.046l-2.056-1.191a.629.629 0 01.045.12l2.053 1.194a1.156 1.156 0 00-.041-.123z"
                    />
                    <path
                        fill="#992e66"
                        d="M214.248 93.169l-2.053-1.195c.012.038.018.076.031.12l2.056 1.194c-.013-.04-.022-.081-.035-.12z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M214.282 93.288l-2.056-1.194c.006.034.013.075.022.113l2.053 1.195-.019-.114z"
                    />
                    <path
                        fill="#a3316d"
                        d="M214.3 93.401l-2.052-1.194c.003.037.01.072.016.113l2.056 1.191-.02-.11z"
                    />
                    <path
                        fill="#a83270"
                        d="M214.32 93.511l-2.056-1.191c.006.035.01.076.012.113l2.056 1.188a1.214 1.214 0 01-.012-.11z"
                    />
                    <path
                        fill="#ad3474"
                        d="M214.332 93.621l-2.056-1.188a.591.591 0 01.007.107l2.055 1.195c0-.038-.006-.076-.006-.114z"
                    />
                    <path
                        fill="#b33577"
                        d="M214.338 93.735l-2.055-1.195c0 .038 0 .075.003.113l2.052 1.194v-.112z"
                    />
                    <path
                        fill="#b8377a"
                        d="M214.338 93.847l-2.052-1.194v.006c0 .038-.003.07-.003.1l2.055 1.196v-.108z"
                    />
                    <path
                        fill="#bd387e"
                        d="M214.338 93.955l-2.055-1.195v.107l2.049 1.194a.604.604 0 00.006-.106z"
                    />
                    <path
                        fill="#c23a81"
                        d="M214.332 94.061l-2.05-1.194c-.006.038-.009.072-.012.107l2.056 1.194c0-.037.006-.072.006-.107z"
                    />
                    <path
                        fill="#c73b85"
                        d="M214.326 94.168l-2.056-1.194c-.006.035-.006.075-.012.11l2.055 1.191c.004-.038.007-.069.013-.107z"
                    />
                    <path
                        fill="#cc3d88"
                        d="M214.313 94.275l-2.055-1.191c-.007.034-.01.072-.02.11l2.056 1.194.02-.113z"
                    />
                    <path
                        fill="#d13e8b"
                        d="M214.294 94.388l-2.055-1.194c0 .038-.01.075-.013.113l2.056 1.195a.724.724 0 01.012-.114z"
                    />
                    <path
                        fill="#d6408f"
                        d="M214.282 94.502l-2.056-1.195a.765.765 0 00-.025.12l2.05 1.194c.012-.044.018-.082.03-.12z"
                    />
                    <path
                        fill="#db4192"
                        d="M214.25 94.621l-2.05-1.194c-.012.04-.018.081-.03.122l2.055 1.191c.006-.04.02-.081.026-.119z"
                    />
                    <path
                        fill="#e04396"
                        d="M214.225 94.74l-2.055-1.191c-.01.041-.02.085-.032.123l2.05 1.194a.723.723 0 00.037-.126z"
                    />
                    <path
                        fill="#e64499"
                        d="M214.187 94.866l-2.049-1.194-.038.132 2.053 1.194a.97.97 0 00.034-.132z"
                    />
                    <path
                        fill="#eb469c"
                        d="M214.153 94.998l-2.053-1.194c-.012.043-.028.088-.044.132l2.056 1.191c.013-.044.025-.085.041-.129z"
                    />
                    <path
                        fill="#f047a0"
                        d="M214.112 95.127l-2.056-1.191a.882.882 0 01-.044.128l2.056 1.198a2.14 2.14 0 01.044-.135z"
                    />
                    <path
                        fill="#f549a3"
                        d="M214.068 95.262l-2.056-1.198a2.05 2.05 0 01-.05.13l2.056 1.194c.016-.041.032-.088.05-.126z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-23)">
                    <path
                        fill="#f9fafd"
                        d="M210.038 97.686l-2.056-1.191c-.031.037-.062.081-.094.122l2.056 1.195.094-.126z"
                    />
                    <path
                        fill="#fafafd"
                        d="M209.944 97.812l-2.056-1.195c-.078.11-.157.22-.233.333l2.053 1.192c.072-.113.154-.22.236-.33z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M209.708 98.142l-2.053-1.192c-.135.198-.263.403-.39.617l2.056 1.19c.12-.21.252-.414.387-.615z"
                    />
                    <path
                        fill="#fafafd"
                        d="M209.321 98.758l-2.055-1.191a9.526 9.526 0 00-.227.405l2.056 1.191c.072-.138.145-.273.226-.405z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M209.095 99.163l-2.056-1.19c-.05.093-.1.188-.144.282l2.053 1.195c.047-.095.097-.19.147-.287z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M208.948 99.45l-2.053-1.195a9.64 9.64 0 00-.129.264l2.053 1.191c.043-.088.084-.173.129-.26zM208.819 99.71l-2.053-1.191a5.567 5.567 0 00-.11.251l2.05 1.195c.037-.088.075-.17.113-.255z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M208.705 99.965l-2.05-1.195c-.04.082-.078.17-.112.255l2.056 1.191c.031-.084.072-.17.107-.251z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M208.599 100.216l-2.056-1.191c-.038.088-.072.176-.107.264l2.056 1.195c.034-.092.069-.18.107-.268z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M208.492 100.484l-2.056-1.195c-.035.091-.07.186-.1.28l2.049 1.191c.037-.094.07-.185.107-.276z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M208.385 100.76l-2.05-1.191c-.037.094-.069.191-.104.289l2.053 1.195c.032-.1.07-.195.1-.293z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M208.284 101.053l-2.053-1.195c-.034.1-.069.204-.097.308l2.05 1.194a8.51 8.51 0 01.1-.307z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M208.184 101.36l-2.05-1.194c-.031.107-.069.214-.094.32l2.056 1.195a6.15 6.15 0 01.088-.32z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M208.096 101.681l-2.056-1.195c-.032.108-.057.22-.088.328l2.056 1.19c.025-.106.056-.216.088-.323z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M208.008 102.005l-2.056-1.191c-.026.11-.054.22-.076.333l2.056 1.194c.019-.113.05-.226.076-.336z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M207.932 102.341l-2.056-1.194c-.025.107-.044.217-.07.327l2.054 1.194c.022-.11.047-.22.072-.327z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M207.86 102.668l-2.053-1.194a34.29 34.29 0 01-.056.333l2.056 1.191c.012-.11.034-.22.053-.33z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M207.807 102.998l-2.056-1.191-.048.327 2.053 1.194c.013-.11.031-.22.05-.33z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M207.756 103.328l-2.053-1.194c-.003.044-.009.09-.015.138l2.056 1.195c.002-.05.006-.095.012-.139z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-24)">
                    <path
                        fill="#818184"
                        d="M213.666 92.364l-2.056-1.191a.683.683 0 00-.182-.085l2.052 1.19a1.161 1.161 0 01.186.086z"
                    />
                    <path
                        fill="#868689"
                        d="M213.48 92.279l-2.052-1.191a1.247 1.247 0 00-.164-.047l2.056 1.191a1.591 1.591 0 01.16.047z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M213.32 92.232l-2.056-1.191a.94.94 0 00-.132-.02l2.056 1.192.132.02z"
                    />
                    <path
                        fill="#909093"
                        d="M213.188 92.213l-2.056-1.191c-.04-.004-.081-.004-.123-.004l2.06 1.195z"
                    />
                    <path
                        fill="#959598"
                        d="M213.068 92.213l-2.059-1.195h-.11l2.06 1.195z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M212.959 92.213l-2.06-1.195c-.03.004-.062.007-.1.013l2.056 1.194a.543.543 0 01.104-.012z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M212.855 92.225l-2.056-1.194c-.035.006-.063.01-.1.02l2.055 1.19c.032-.009.066-.009.1-.016z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M212.754 92.241l-2.056-1.19c-.031.002-.063.012-.094.018l2.053 1.192a.798.798 0 01.097-.02z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M212.657 92.26l-2.053-1.191c-.031.006-.066.019-.094.025l2.05 1.195c.03-.01.066-.02.097-.028z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M212.56 92.289l-2.05-1.195c-.032.013-.063.022-.094.032l2.052 1.194c.032-.013.066-.022.091-.031z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M212.468 92.32l-2.052-1.194c-.032.009-.063.022-.095.034l2.05 1.195c.038-.01.066-.029.097-.035z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M212.37 92.355l-2.049-1.195a1.084 1.084 0 00-.094.041l2.056 1.195a.522.522 0 01.088-.041z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M212.283 92.396l-2.056-1.195c-.032.013-.063.031-.094.044l2.05 1.194a.867.867 0 01.1-.043z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M212.182 92.44l-2.05-1.195c-.03.016-.063.031-.094.05l2.05 1.195c.034-.02.062-.032.094-.05z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M212.088 92.49l-2.05-1.195a.839.839 0 00-.075.041l2.05 1.192.075-.038z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-25)">
                    <path
                        fill="#c6c7ca"
                        d="M212.012 92.528l-2.05-1.192a.163.163 0 01-.024.016l2.056 1.191a.048.048 0 00.018-.015z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M211.994 92.543l-2.056-1.191c-.032.019-.063.035-.1.06l2.055 1.191a1.04 1.04 0 00.1-.06z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M211.893 92.603l-2.056-1.191c-.031.021-.063.04-.094.062l2.05 1.198c.034-.025.065-.047.1-.069z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M211.792 92.672l-2.049-1.198a1.226 1.226 0 00-.104.073l2.052 1.194c.039-.025.07-.047.101-.069z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M211.691 92.741l-2.052-1.194c-.035.025-.066.053-.104.082l2.056 1.19c.032-.027.07-.053.1-.078z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M211.591 92.82l-2.056-1.191c-.031.025-.07.053-.1.081l2.053 1.195c.034-.029.066-.057.103-.085z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M211.488 92.905l-2.053-1.195c-.038.031-.073.063-.107.092l2.055 1.19c.032-.03.07-.06.105-.087z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M211.383 92.993l-2.055-1.191c-.032.028-.07.062-.1.094l2.052 1.191a1.386 1.386 0 00.103-.094z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M211.28 93.087l-2.053-1.191c-.031.028-.063.066-.094.097l2.05 1.191c.037-.031.063-.066.097-.097z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M211.182 93.185l-2.05-1.192a.97.97 0 00-.093.1l2.049 1.195.094-.103z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M211.088 93.288l-2.05-1.194a.69.69 0 00-.09.1L211 93.386c.032-.032.06-.066.088-.098z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M211 93.386l-2.052-1.192c-.032.031-.06.067-.092.1l2.05 1.195c.031-.037.063-.069.094-.103zM210.906 93.49l-2.05-1.195-.088.11 2.053 1.191c.028-.038.06-.069.085-.107zM210.82 93.596l-2.052-1.191-.104.135 2.056 1.195.1-.139z"
                    />
                    <path
                        fill="#fafafd"
                        d="M210.72 93.735l-2.056-1.195-.147.208 2.055 1.194c.048-.07.095-.141.148-.207z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M210.573 93.942l-2.056-1.194q-.085.132-.17.273l2.056 1.191a3.092 3.092 0 01.17-.27z"
                    />
                    <path
                        fill="#fafafd"
                        d="M210.403 94.212l-2.056-1.191-.113.201 2.052 1.192c.038-.066.08-.133.117-.202z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M210.286 94.414l-2.052-1.192a1.484 1.484 0 00-.07.138l2.05 1.192a1.41 1.41 0 00.072-.138zM210.214 94.552l-2.05-1.192c-.018.041-.04.08-.062.123l2.056 1.192.056-.123z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M210.158 94.675l-2.056-1.192a1.038 1.038 0 00-.044.11l2.05 1.194a1.15 1.15 0 01.05-.112z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M210.107 94.787l-2.05-1.194a1.26 1.26 0 00-.05.11l2.056 1.195c.013-.038.032-.073.044-.11z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M210.063 94.898l-2.055-1.195a.818.818 0 00-.045.113l2.05 1.195c.016-.038.031-.076.05-.113z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M210.013 95.01l-2.05-1.194a1.767 1.767 0 00-.043.113l2.049 1.195a1.208 1.208 0 00.044-.113z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M209.969 95.124l-2.05-1.195c-.015.038-.025.08-.043.114l2.056 1.197c.012-.04.028-.078.037-.116z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M209.932 95.24l-2.056-1.197c-.013.043-.022.082-.038.125l2.056 1.189c.012-.038.022-.076.038-.117z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M209.894 95.357l-2.056-1.189a1.106 1.106 0 01-.038.123l2.056 1.191.038-.125z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M209.856 95.482l-2.056-1.191c-.006.038-.019.078-.031.123l2.056 1.19c.012-.04.019-.084.03-.122z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M209.825 95.605l-2.056-1.191c-.007.037-.02.081-.025.119l2.055 1.195a.81.81 0 01.026-.123z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M209.8 95.728l-2.056-1.195a.76.76 0 00-.026.123l2.056 1.19a.764.764 0 01.025-.118z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M209.774 95.847l-2.056-1.191-.019.116 2.053 1.194c.01-.04.01-.082.022-.12z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M209.752 95.966l-2.053-1.194-.018.116 2.055 1.192c.007-.038.01-.076.016-.114z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M209.736 96.08l-2.055-1.192c0 .038-.01.079-.013.116l2.053 1.189c.003-.035.01-.073.015-.113z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M209.72 96.193l-2.052-1.189a.716.716 0 00-.006.114l2.05 1.194.009-.12z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M209.711 96.312l-2.049-1.194c-.003.037-.007.075-.007.113l2.053 1.194c.003-.038.003-.075.003-.113z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M209.708 96.425l-2.053-1.194-.002.103v.004l2.052 1.194v-.003l.003-.104z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M209.705 96.532l-2.052-1.194.002.11 2.056 1.191a1.139 1.139 0 01-.006-.107z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M209.711 96.64l-2.056-1.192c.004.038.007.072.007.103l2.053 1.195c-.004-.031-.004-.07-.004-.107z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M209.715 96.746l-2.053-1.195a1.06 1.06 0 00.01.107l2.052 1.191a10.042 10.042 0 01-.01-.103z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M209.724 96.85l-2.053-1.192c.01.035.01.07.016.107l2.056 1.191a3.895 3.895 0 01-.019-.107z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M209.743 96.956l-2.056-1.19a.848.848 0 00.025.106l2.05 1.194-.019-.11z"
                    />
                    <path
                        fill="#959598"
                        d="M209.762 97.066l-2.05-1.194c.006.04.02.079.025.113l2.06 1.195a1.062 1.062 0 01-.035-.114z"
                    />
                    <path
                        fill="#909093"
                        d="M209.796 97.18l-2.059-1.195c.013.044.028.085.044.126l2.056 1.194a.565.565 0 01-.04-.125z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M209.837 97.305l-2.056-1.194c.016.047.038.095.057.138l2.056 1.195c-.02-.044-.042-.094-.057-.139z"
                    />
                    <path
                        fill="#868689"
                        d="M209.894 97.444l-2.056-1.195c.031.063.063.12.094.173l2.056 1.192c-.031-.054-.07-.114-.094-.17z"
                    />
                    <path
                        fill="#818184"
                        d="M209.988 97.614l-2.056-1.192a.63.63 0 01.05.073l2.056 1.19a.358.358 0 01-.05-.071z"
                    />
                </g>
                <path
                    fill="#f8f9fd"
                    d="M212.012 92.528a5.093 5.093 0 00-2.307 4.001 1.936 1.936 0 00.333 1.157 12.154 12.154 0 00-2.294 5.78l8.594-4.966c-.249-1.804-1.126-2.933-2.32-3.112a4.324 4.324 0 00.32-1.534c0-1.477-1.04-2.065-2.326-1.326z"
                />
                <path
                    fill="#e53399"
                    d="M202.3 100.396c.002-.123.005-.249.015-.375.01-.125.015-.248.028-.373.013-.126.028-.252.044-.375.019-.132.035-.257.057-.39.018-.131.04-.257.063-.39.028-.131.056-.267.081-.402.035-.135.063-.267.094-.402.035-.135.076-.27.114-.409.025-.107.056-.214.088-.32 0-.006.006-.01.006-.016l.019-.066c.04-.138.085-.27.132-.402.038-.13.088-.264.132-.393.047-.126.094-.249.138-.374.054-.126.104-.252.157-.375.038-.097.079-.191.123-.289l.003-.006c.006-.022.02-.047.025-.072.063-.126.117-.249.176-.371.06-.132.126-.27.195-.402.076-.158.154-.309.236-.466.088-.157.18-.323.274-.48.015-.03.03-.06.05-.092.019-.031.038-.069.057-.1a19.532 19.532 0 011.056-1.61c.113-.148.226-.298.342-.443.098-.126.195-.245.299-.368.094-.116.195-.232.295-.346.095-.113.198-.22.296-.326a.505.505 0 01.056-.057.266.266 0 01.032-.035c.075-.078.15-.16.226-.242.107-.106.217-.214.327-.317.107-.107.22-.214.333-.314.113-.101.233-.202.346-.3.05-.046.11-.094.167-.137a.134.134 0 01.044-.032 1.32 1.32 0 01.128-.107c.11-.088.224-.176.337-.258.11-.084.22-.163.333-.238.11-.076.217-.145.324-.214.11-.07.22-.139.327-.201.025-.013.05-.029.075-.044.082-.044.164-.095.245-.139.104-.053.208-.107.315-.16.069-.035.138-.066.207-.097a.432.432 0 01.041-.02c.022-.009.04-.021.06-.031l.308-.132.311-.113a.377.377 0 00.054-.019.111.111 0 00.037-.012c.076-.025.148-.044.214-.07.107-.031.214-.062.32-.088.05-.012.101-.018.151-.031a.48.48 0 01.07-.016c.028-.006.063-.016.094-.022.113-.019.223-.04.333-.056.072-.01.139-.013.205-.02l.072-.008c.025 0 .044-.004.07-.004.119-.01.238-.012.357-.012.057 0 .1.003.154.006a.836.836 0 01.123.006c.037.004.082.004.12.004a4.22 4.22 0 01.446.065h.006c.038.013.069.023.107.032a4.078 4.078 0 01.421.116.1.1 0 01.032.016 3.612 3.612 0 01.59.27l2.057 1.195a3.624 3.624 0 00-.592-.27 3.234 3.234 0 00-.452-.133c-.038-.009-.076-.025-.113-.031a3.776 3.776 0 00-.573-.07.752.752 0 00-.116-.005 5.336 5.336 0 00-.588.006.327.327 0 01-.066.01 7.1 7.1 0 00-.638.096.416.416 0 01-.069.016c-.22.054-.446.114-.673.189a.481.481 0 01-.05.016 7.98 7.98 0 00-.723.295l-.054.02c-.248.115-.499.247-.757.395a11.601 11.601 0 00-1.534 1.063.122.122 0 01-.031.025 14.614 14.614 0 00-1.409 1.32.197.197 0 00-.025.025 17.918 17.918 0 00-2.404 3.257 1.276 1.276 0 01-.05.088 18.188 18.188 0 00-.903 1.785.026.026 0 00-.006.019 18.78 18.78 0 00-.701 1.892.055.055 0 01-.007.022 15.115 15.115 0 00-.44 1.902v.003a12.4 12.4 0 00-.147 1.877c0 .289.016.569.037.836a.305.305 0 01.007.075c.025.252.063.49.107.724a.64.64 0 01.015.081c.048.223.104.437.167.641.012.038.028.079.037.12.064.182.133.358.208.521a.902.902 0 01.034.086 5.288 5.288 0 00.3.546 4.323 4.323 0 00.537.664l.141.138a4.187 4.187 0 00.648.49l-2.05-1.194a3.307 3.307 0 01-.65-.497 1.388 1.388 0 01-.142-.135 3.894 3.894 0 01-.534-.657l-.013-.012c-.1-.164-.195-.34-.286-.525a.023.023 0 01-.003-.016.238.238 0 01-.029-.063 5.217 5.217 0 01-.15-.355c-.022-.063-.04-.129-.067-.195a.588.588 0 01-.03-.107c-.013-.034-.029-.07-.038-.104a6.519 6.519 0 01-.101-.393c-.012-.047-.019-.09-.031-.14l-.02-.099c-.005-.047-.018-.09-.024-.135a4.363 4.363 0 01-.057-.368c-.006-.072-.016-.14-.022-.213a.415.415 0 00-.01-.066.735.735 0 00-.006-.088 6.306 6.306 0 01-.022-.365 7.102 7.102 0 01-.009-.37v-.02c0-.12 0-.232.006-.348z"
                />
                <path
                    fill="#ff4caa"
                    d="M219.714 93.062a16.883 16.883 0 01-7.664 13.265c-4.237 2.452-7.692.481-7.702-4.388a16.874 16.874 0 017.658-13.278c4.237-2.449 7.692-.48 7.708 4.401zm-3.376 5.438c-.249-1.804-1.126-2.933-2.32-3.112a4.324 4.324 0 00.32-1.534c0-1.477-1.04-2.065-2.326-1.326a5.093 5.093 0 00-2.307 4.001 1.936 1.936 0 00.333 1.157 12.154 12.154 0 00-2.294 5.78l8.594-4.966z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-26)">
                    <path
                        fill="#852858"
                        d="M171.575 156.05l-2.056-1.191a2.618 2.618 0 01.893.886l2.056 1.195a2.68 2.68 0 00-.893-.89z"
                    />
                    <path
                        fill="#8a295c"
                        d="M172.468 156.94l-2.056-1.195a4.338 4.338 0 01.22.396l2.053 1.192a2.892 2.892 0 00-.217-.393z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M172.685 157.333l-2.053-1.192a3.006 3.006 0 01.148.352l2.056 1.195a5.236 5.236 0 00-.151-.355z"
                    />
                    <path
                        fill="#942c63"
                        d="M172.836 157.688l-2.056-1.195c.038.107.075.217.11.334l2.052 1.191c-.034-.113-.072-.223-.106-.33z"
                    />
                    <path
                        fill="#992e66"
                        d="M172.942 158.018l-2.052-1.191a3.295 3.295 0 01.081.323l2.056 1.195a3.457 3.457 0 00-.085-.327z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M173.027 158.345l-2.056-1.195c.026.1.048.214.067.321l2.052 1.191a6.526 6.526 0 00-.063-.317z"
                    />
                    <path
                        fill="#a3316d"
                        d="M173.09 158.662l-2.052-1.19c.009.074.022.15.037.232l2.05 1.19a5.083 5.083 0 00-.035-.232z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-27)">
                    <path
                        fill="#818184"
                        d="M171.575 156.05l-2.056-1.191a1.978 1.978 0 00-.37-.173l2.055 1.194a2.349 2.349 0 01.37.17z"
                    />
                    <path
                        fill="#868689"
                        d="M171.204 155.88l-2.056-1.194a2.87 2.87 0 00-.292-.082l2.052 1.194a2.368 2.368 0 01.296.082z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M170.908 155.798l-2.052-1.194-.1-.016 2.052 1.195c.035.003.07.01.1.015z"
                    />
                </g>
                <g clipPath="url(#clip-path-28)">
                    <path
                        fill="#b8377a"
                        d="M171.129 154.24l-2.05-1.192v.003c0 .038-.006.07-.006.1l2.056 1.196v-.108z"
                    />
                </g>
                <path
                    fill="#dc4193"
                    d="M173.125 158.895L171.075 157.704 162.478 162.664 164.534 163.858 173.125 158.895z"
                />
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-29)">
                    <path
                        fill="#852858"
                        d="M170.456 152.756l-2.056-1.192a1.176 1.176 0 01.4.387l2.052 1.198a1.213 1.213 0 00-.396-.393z"
                    />
                    <path
                        fill="#8a295c"
                        d="M170.852 153.149l-2.053-1.198c.032.054.06.107.092.163l2.05 1.192a.924.924 0 00-.089-.157z"
                    />
                    <path
                        fill="#8f2b5f"
                        d="M170.94 153.306l-2.05-1.192c.02.041.035.082.054.133l2.053 1.188c-.02-.044-.035-.085-.057-.13z"
                    />
                    <path
                        fill="#942c63"
                        d="M170.997 153.435l-2.053-1.188c.016.037.025.075.041.119l2.053 1.195c-.01-.042-.029-.086-.041-.126z"
                    />
                    <path
                        fill="#992e66"
                        d="M171.038 153.56l-2.053-1.194c.013.04.019.082.028.12l2.053 1.194c-.006-.041-.019-.082-.028-.12z"
                    />
                    <path
                        fill="#9e2f69"
                        d="M171.066 153.68l-2.053-1.195c.01.038.016.076.025.114l2.053 1.194a.716.716 0 00-.025-.113z"
                    />
                    <path
                        fill="#a3316d"
                        d="M171.091 153.793l-2.053-1.194.016.113 2.056 1.194a14.017 14.017 0 00-.019-.113z"
                    />
                    <path
                        fill="#a83270"
                        d="M171.11 153.906l-2.056-1.194a1 1 0 01.012.113l2.056 1.188c-.006-.035-.009-.075-.012-.107z"
                    />
                    <path
                        fill="#ad3474"
                        d="M171.122 154.013l-2.056-1.188c0 .038.007.072.007.107l2.056 1.194c0-.037-.007-.072-.007-.113z"
                    />
                    <path
                        fill="#b33577"
                        d="M171.129 154.126l-2.056-1.194a.7.7 0 00.006.116l2.05 1.191v-.113z"
                    />
                    <path
                        fill="#b8377a"
                        d="M171.129 154.24l-2.05-1.192v.003c0 .038-.006.07-.006.1l2.056 1.196v-.108z"
                    />
                    <path
                        fill="#bd387e"
                        d="M171.129 154.347l-2.056-1.195a.588.588 0 01-.007.107l2.056 1.197a.635.635 0 00.007-.11z"
                    />
                    <path
                        fill="#c23a81"
                        d="M171.122 154.456l-2.056-1.197c0 .037-.003.072-.003.11l2.053 1.191c0-.038.006-.069.006-.104z"
                    />
                    <path
                        fill="#c73b85"
                        d="M171.116 154.56l-2.053-1.191a1.076 1.076 0 00-.015.106l2.056 1.195a.647.647 0 01.012-.11z"
                    />
                    <path
                        fill="#cc3d88"
                        d="M171.104 154.67l-2.056-1.195a.612.612 0 01-.02.11l2.057 1.195.019-.11z"
                    />
                    <path
                        fill="#d13e8b"
                        d="M171.085 154.78l-2.056-1.194a.503.503 0 01-.016.116l2.053 1.195c.01-.041.012-.08.019-.117z"
                    />
                    <path
                        fill="#d6408f"
                        d="M171.066 154.896l-2.053-1.194a1.176 1.176 0 01-.028.116l2.059 1.195c.003-.038.016-.082.022-.117z"
                    />
                    <path
                        fill="#db4192"
                        d="M171.044 155.013l-2.059-1.195c-.006.044-.016.082-.025.126l2.052 1.188.032-.119z"
                    />
                    <path
                        fill="#e04396"
                        d="M171.012 155.132l-2.052-1.188c-.013.038-.019.082-.032.126l2.053 1.191a1.78 1.78 0 00.031-.129z"
                    />
                    <path
                        fill="#e64499"
                        d="M170.98 155.261l-2.052-1.191-.037.125 2.053 1.195c.009-.044.025-.088.037-.129z"
                    />
                    <path
                        fill="#eb469c"
                        d="M170.944 155.39l-2.053-1.195a1.892 1.892 0 01-.045.133l2.056 1.19c.013-.04.025-.084.042-.128z"
                    />
                    <path
                        fill="#f047a0"
                        d="M170.902 155.519l-2.056-1.191c-.015.044-.028.087-.044.128l2.053 1.195c.016-.041.032-.085.047-.132z"
                    />
                    <path
                        fill="#f549a3"
                        d="M170.855 155.65l-2.053-1.194c-.015.048-.03.089-.047.132l2.053 1.195c.02-.044.031-.085.047-.132z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-30)">
                    <path
                        fill="#f9fafd"
                        d="M166.828 158.08l-2.055-1.194-.095.126 2.056 1.191a1.21 1.21 0 01.094-.122z"
                    />
                    <path
                        fill="#fafafd"
                        d="M166.734 158.203l-2.056-1.19c-.078.106-.157.219-.232.332l2.052 1.195c.079-.12.154-.227.236-.337z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M166.498 158.54l-2.052-1.195a9.068 9.068 0 00-.39.616l2.056 1.192c.122-.211.251-.419.386-.613z"
                    />
                    <path
                        fill="#fafafd"
                        d="M166.112 159.153l-2.056-1.192c-.075.126-.151.264-.226.403l2.056 1.194a5.54 5.54 0 01.226-.405z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M165.886 159.558l-2.056-1.194c-.05.094-.098.188-.145.289l2.05 1.188.15-.283zM165.735 159.841l-2.05-1.188c-.044.085-.085.17-.129.258l2.053 1.194c.044-.088.088-.176.126-.264z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M165.609 160.105l-2.053-1.194c-.035.084-.072.17-.11.251l2.05 1.194c.037-.084.075-.17.113-.251z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M165.496 160.356l-2.05-1.194c-.038.088-.078.17-.113.255l2.056 1.191c.031-.081.07-.167.107-.252z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M165.389 160.608l-2.056-1.191c-.038.088-.07.179-.107.267l2.056 1.191c.034-.088.07-.179.107-.267z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M165.282 160.875l-2.056-1.191c-.031.088-.07.182-.103.276l2.055 1.192c.035-.091.066-.185.104-.277z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M165.178 161.152l-2.055-1.192c-.035.095-.067.195-.105.293l2.056 1.194c.032-.1.063-.198.104-.295z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M165.074 161.447l-2.056-1.194c-.03.1-.065.204-.094.305l2.05 1.194c.031-.103.069-.204.1-.305z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M164.974 161.752l-2.05-1.194a4.15 4.15 0 00-.094.32l2.056 1.195c.025-.107.057-.214.088-.321z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M164.886 162.073l-2.056-1.195c-.031.114-.056.22-.085.327l2.053 1.195c.028-.11.053-.22.088-.327z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M164.798 162.4l-2.053-1.195c-.028.114-.053.223-.078.333l2.05 1.195c.024-.113.056-.223.081-.333z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M164.716 162.733l-2.05-1.195c-.024.107-.05.22-.069.33l2.056 1.195c.02-.11.044-.22.063-.33z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M164.653 163.063l-2.056-1.194-.056.33 2.056 1.191a3.82 3.82 0 01.056-.327z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M164.597 163.39l-2.056-1.191c-.02.106-.032.22-.044.327l2.052 1.19a4.12 4.12 0 01.048-.326z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M164.55 163.717l-2.053-1.191c-.006.044-.016.094-.019.138l2.056 1.194c.006-.047.006-.094.015-.141z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-31)">
                    <path
                        fill="#818184"
                        d="M170.456 152.756l-2.056-1.192a.983.983 0 00-.182-.084l2.053 1.194c.062.025.122.05.185.082z"
                    />
                    <path
                        fill="#868689"
                        d="M170.27 152.674l-2.052-1.194a.967.967 0 00-.164-.044l2.056 1.194a.796.796 0 01.16.044z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M170.11 152.63l-2.056-1.194a.62.62 0 00-.132-.02l2.053 1.192a.928.928 0 01.135.022z"
                    />
                    <path
                        fill="#909093"
                        d="M169.975 152.608l-2.052-1.191a.717.717 0 00-.12-.007l2.05 1.192c.044 0 .084.003.122.006z"
                    />
                    <path
                        fill="#959598"
                        d="M169.853 152.602l-2.05-1.192c-.035 0-.075 0-.11.003l2.056 1.195c.034-.003.072-.006.104-.006z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M169.749 152.608l-2.056-1.195c-.035.004-.066.004-.104.01l2.053 1.194a.632.632 0 01.107-.009z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M169.642 152.617l-2.053-1.194c-.031.003-.063.013-.1.019l2.056 1.194a5.19 5.19 0 01.097-.019z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M169.545 152.636l-2.056-1.194-.095.019 2.056 1.194.094-.019z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M169.45 152.655l-2.056-1.194a.888.888 0 01-.097.025l2.053 1.194a.962.962 0 01.1-.025z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M169.35 152.68l-2.053-1.194c-.028.013-.06.019-.091.034l2.05 1.192.094-.032z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M169.255 152.712l-2.05-1.192c-.03.01-.062.023-.094.032l2.05 1.194a.893.893 0 00.094-.034z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M169.16 152.746l-2.049-1.194c-.031.012-.062.028-.094.04l2.05 1.195a.832.832 0 00.094-.04z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M169.066 152.787l-2.05-1.194a1.403 1.403 0 00-.093.044l2.052 1.194a.824.824 0 01.091-.044z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M168.975 152.831l-2.052-1.194c-.032.018-.066.031-.095.05l2.05 1.195c.031-.02.066-.032.097-.05z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M168.878 152.882l-2.05-1.195c-.025.012-.05.029-.075.044l2.053 1.192.072-.041z"
                    />
                </g>
                <g style={{isolation: "isolate"}} clipPath="url(#clip-path-32)">
                    <path
                        fill="#c6c7ca"
                        d="M168.806 152.923l-2.053-1.192c-.007.006-.019.006-.025.013l2.053 1.191a.097.097 0 00.025-.012z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M168.78 152.935l-2.052-1.191a1.159 1.159 0 00-.1.063l2.055 1.19c.035-.021.07-.04.098-.062z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M168.683 152.998l-2.056-1.191a.735.735 0 00-.097.062l2.053 1.195c.034-.025.069-.047.1-.066z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M168.583 153.064l-2.053-1.195c-.035.022-.066.05-.1.073l2.055 1.19c.031-.024.066-.046.098-.068z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M168.485 153.133l-2.056-1.191-.103.078 2.056 1.192a1.212 1.212 0 01.103-.08z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M168.381 153.212l-2.056-1.192-.1.082 2.05 1.198a6.97 6.97 0 01.107-.088z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M168.275 153.3l-2.05-1.198c-.038.031-.07.063-.104.091l2.053 1.191.1-.084z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M168.174 153.384l-2.053-1.19a1.593 1.593 0 01-.104.097l2.056 1.191c.032-.035.067-.063.1-.098z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M168.073 153.482l-2.056-1.191-.094.094 2.05 1.195c.031-.032.062-.064.1-.098z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M167.973 153.58l-2.05-1.195c-.034.034-.069.066-.097.1l2.055 1.195a.914.914 0 01.092-.1z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M167.881 153.68l-2.055-1.195c-.032.032-.06.063-.091.098l2.056 1.191.09-.094z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.79 153.774l-2.055-1.191c-.029.037-.057.07-.088.104l2.055 1.194a1.313 1.313 0 01.089-.107zM167.702 153.881l-2.055-1.194c-.026.04-.063.075-.089.11l2.056 1.19.088-.106z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.614 153.988l-2.056-1.191-.103.135 2.053 1.194c.037-.044.069-.09.106-.138z"
                    />
                    <path
                        fill="#fafafd"
                        d="M167.508 154.126l-2.053-1.194-.148.208 2.056 1.194c.044-.07.094-.142.145-.208z"
                    />
                    <path
                        fill="#fafbfe"
                        d="M167.363 154.334l-2.056-1.194q-.085.131-.17.273l2.056 1.191c.05-.091.11-.182.17-.27z"
                    />
                    <path
                        fill="#fafafd"
                        d="M167.193 154.604l-2.056-1.191c-.038.066-.075.135-.113.204l2.056 1.195c.035-.07.075-.142.113-.208z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.08 154.812l-2.056-1.195a1.37 1.37 0 00-.072.138l2.053 1.195c.025-.05.05-.094.075-.138z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M167.005 154.95l-2.053-1.195c-.022.038-.038.076-.06.12l2.056 1.194c.019-.044.038-.081.057-.119z"
                    />
                    <path
                        fill="#f9fafd"
                        d="M166.948 155.07l-2.056-1.195c-.016.038-.031.075-.044.113l2.05 1.191a.579.579 0 01.05-.11z"
                    />
                    <path
                        fill="#f8f9fd"
                        d="M166.898 155.18l-2.05-1.192a.648.648 0 00-.05.107l2.053 1.198c.015-.041.03-.076.047-.114z"
                    />
                    <path
                        fill="#f3f4f8"
                        d="M166.85 155.293l-2.052-1.198a.984.984 0 00-.044.113l2.05 1.195c.015-.038.03-.076.047-.11z"
                    />
                    <path
                        fill="#eeeff3"
                        d="M166.803 155.403l-2.05-1.195a.805.805 0 00-.043.113l2.052 1.195c.016-.038.029-.076.041-.113z"
                    />
                    <path
                        fill="#e9eaee"
                        d="M166.762 155.516l-2.052-1.195c-.013.038-.032.082-.044.12l2.055 1.194c.013-.04.029-.081.041-.12z"
                    />
                    <path
                        fill="#e4e5e9"
                        d="M166.721 155.635l-2.055-1.195c-.013.038-.022.082-.038.12l2.056 1.195c.012-.044.025-.082.037-.12z"
                    />
                    <path
                        fill="#dfe0e4"
                        d="M166.684 155.755l-2.056-1.195c-.013.044-.022.082-.035.122l2.053 1.192.038-.12z"
                    />
                    <path
                        fill="#dadbdf"
                        d="M166.646 155.874l-2.053-1.192c-.012.042-.021.082-.034.123l2.056 1.195c.01-.044.022-.085.031-.126z"
                    />
                    <path
                        fill="#d5d6da"
                        d="M166.615 156l-2.056-1.195c-.006.038-.019.082-.025.12l2.052 1.194c.01-.044.016-.082.029-.12z"
                    />
                    <path
                        fill="#d0d1d5"
                        d="M166.586 156.12l-2.052-1.196c-.01.042-.02.082-.025.123l2.052 1.192c.01-.041.016-.08.025-.12z"
                    />
                    <path
                        fill="#cbcccf"
                        d="M166.561 156.239l-2.052-1.192c-.006.038-.016.079-.02.117l2.057 1.194a.864.864 0 01.015-.12z"
                    />
                    <path
                        fill="#c6c7ca"
                        d="M166.546 156.358l-2.056-1.194-.02.12 2.057 1.194a.763.763 0 01.019-.12z"
                    />
                    <path
                        fill="#c1c2c5"
                        d="M166.527 156.478l-2.056-1.195c-.004.035-.006.075-.013.113l2.05 1.195.019-.113z"
                    />
                    <path
                        fill="#bcbdc0"
                        d="M166.508 156.59l-2.05-1.194a1.438 1.438 0 00-.006.113l2.052 1.195c0-.038.004-.076.004-.113z"
                    />
                    <path
                        fill="#b8b8bb"
                        d="M166.504 156.704l-2.052-1.195a.677.677 0 00-.006.114l2.052 1.191c.004-.035.004-.072.006-.11z"
                    />
                    <path
                        fill="#b3b3b6"
                        d="M166.498 156.814l-2.052-1.191v.11l2.05 1.197v-.009l.002-.107z"
                    />
                    <path
                        fill="#aeaeb1"
                        d="M166.495 156.93l-2.05-1.194v.103l2.057 1.195a1.142 1.142 0 01-.007-.104z"
                    />
                    <path
                        fill="#a9a9ac"
                        d="M166.502 157.034l-2.056-1.195c0 .035.006.073.006.104l2.052 1.195-.002-.104z"
                    />
                    <path
                        fill="#a4a4a7"
                        d="M166.504 157.138l-2.052-1.195a.86.86 0 00.013.107l2.05 1.195c-.007-.035-.007-.07-.01-.107z"
                    />
                    <path
                        fill="#9f9fa2"
                        d="M166.514 157.245l-2.05-1.195c.004.038.01.072.013.107l2.056 1.191c-.006-.034-.01-.065-.019-.103z"
                    />
                    <path
                        fill="#9a9a9d"
                        d="M166.533 157.348l-2.056-1.19a.881.881 0 00.026.106l2.049 1.194-.02-.11z"
                    />
                    <path
                        fill="#959598"
                        d="M166.552 157.458l-2.05-1.194c.007.04.02.082.026.12l2.056 1.188c-.007-.035-.023-.073-.032-.114z"
                    />
                    <path
                        fill="#909093"
                        d="M166.584 157.572l-2.056-1.189a1.261 1.261 0 00.044.12l2.052 1.195a1.415 1.415 0 01-.04-.126z"
                    />
                    <path
                        fill="#8b8b8e"
                        d="M166.624 157.697l-2.052-1.194c.018.05.037.094.056.138l2.056 1.194a1.891 1.891 0 01-.06-.137z"
                    />
                    <path
                        fill="#868689"
                        d="M166.684 157.835l-2.056-1.194c.031.063.063.12.094.173l2.056 1.191a1.23 1.23 0 01-.094-.17z"
                    />
                    <path
                        fill="#818184"
                        d="M166.778 158.005l-2.056-1.19c.02.02.032.046.05.071l2.056 1.195a.4.4 0 01-.05-.076z"
                    />
                </g>
                <path
                    fill="#f8f9fd"
                    d="M168.806 152.923a5.077 5.077 0 00-2.31 3.998 1.956 1.956 0 00.332 1.16 12.138 12.138 0 00-2.294 5.777l8.59-4.963c-.248-1.804-1.121-2.936-2.316-3.112a4.362 4.362 0 00.32-1.537c0-1.475-1.043-2.062-2.322-1.323z"
                />
                <path
                    fill="#e1bb00"
                    d="M159.09 160.79c.006-.126.006-.251.012-.377.013-.125.019-.245.031-.37.013-.13.028-.255.044-.378.016-.129.035-.258.057-.39.019-.128.041-.258.063-.39.031-.132.056-.263.085-.399.028-.135.06-.267.09-.402.032-.135.073-.274.111-.412.028-.107.06-.214.091-.32a.016.016 0 00.006-.013.701.701 0 00.02-.07c.043-.138.087-.27.125-.401.047-.13.094-.258.138-.39.047-.126.094-.252.144-.374.048-.13.101-.252.148-.375.041-.1.085-.194.126-.289 0-.006 0-.006.004-.006l.028-.076c.06-.125.113-.245.173-.37.062-.132.125-.27.194-.403.076-.157.158-.308.24-.459.087-.163.175-.327.27-.487.015-.028.031-.057.05-.085l.056-.107q.274-.466.573-.914c.157-.236.32-.469.487-.692q.165-.226.34-.443c.097-.126.194-.249.298-.368a13.655 13.655 0 01.591-.676l.057-.057c.009-.012.018-.018.031-.034.076-.078.151-.16.23-.242.106-.107.21-.214.323-.314.11-.11.22-.214.333-.321.114-.097.227-.198.346-.296.054-.043.11-.087.164-.138a.497.497 0 00.044-.035l.132-.103c.11-.088.226-.176.336-.258s.223-.16.333-.239c.11-.072.217-.144.327-.213.107-.07.217-.133.324-.198.025-.016.05-.029.075-.048.082-.043.167-.088.246-.135.107-.053.207-.11.314-.163.069-.035.138-.067.204-.098a.635.635 0 00.041-.019.226.226 0 00.063-.031l.308-.129c.107-.04.208-.079.311-.116.02-.007.035-.01.054-.016.012-.006.031-.01.044-.016.07-.022.138-.047.21-.069.104-.031.21-.06.318-.085l.15-.034a.493.493 0 01.063-.016c.032-.006.07-.013.101-.022.113-.022.227-.04.333-.057l.205-.018c.025 0 .047-.007.072-.007l.069-.01c.12-.005.24-.008.359-.008.053 0 .1.006.154.006.04.003.081.003.122.006.04.003.082.003.123.006a4.268 4.268 0 01.443.063s0 .003.006.003c.038.01.072.022.107.029a3.667 3.667 0 01.424.116c.01.003.019.012.029.016a3.934 3.934 0 01.59.27l2.056 1.198a3.584 3.584 0 00-.59-.274 3.918 3.918 0 00-.453-.132.76.76 0 01-.113-.031 4.22 4.22 0 00-.57-.07.771.771 0 00-.122-.006 4.544 4.544 0 00-.584.013.4.4 0 00-.063.006 5.898 5.898 0 00-.642.094 1.441 1.441 0 01-.07.02c-.219.05-.445.113-.671.188a.202.202 0 01-.048.012c-.235.082-.48.183-.732.296-.013.006-.032.012-.044.019-.252.12-.503.248-.76.396a11.93 11.93 0 00-1.535 1.062.077.077 0 01-.031.025 15.429 15.429 0 00-1.409 1.32c-.012.01-.018.02-.028.026a18.159 18.159 0 00-2.405 3.263c-.012.025-.03.053-.044.081a18.684 18.684 0 00-.905 1.789.14.14 0 00-.01.022 16.076 16.076 0 00-.694 1.886c0 .006-.006.016-.006.025a14.435 14.435 0 00-.443 1.905 12.313 12.313 0 00-.152 1.87c.004.293.016.576.042.843l.006.072c.025.251.063.49.106.723a.545.545 0 01.016.082 6.397 6.397 0 00.167.641c.013.038.028.079.038.12.062.182.129.358.204.524.016.025.025.06.041.082a4.037 4.037 0 00.301.55 4.412 4.412 0 00.529.66c.05.048.094.088.144.139a3.895 3.895 0 00.648.49l-2.05-1.195a3.381 3.381 0 01-.654-.493c-.043-.04-.094-.088-.141-.135a4.114 4.114 0 01-.532-.66l-.009-.01a4.79 4.79 0 01-.286-.524c-.006-.007-.006-.013-.012-.02a1.196 1.196 0 01-.019-.062 3.942 3.942 0 01-.154-.352c-.022-.067-.041-.13-.066-.195a1.527 1.527 0 01-.031-.107c-.016-.038-.026-.07-.038-.107a7.078 7.078 0 01-.1-.39c-.014-.047-.02-.094-.033-.141l-.018-.098c-.007-.044-.019-.09-.026-.138-.025-.12-.037-.242-.056-.365-.006-.072-.016-.144-.022-.213a.356.356 0 00-.01-.066c0-.035-.005-.063-.005-.092a3.318 3.318 0 01-.02-.361c-.009-.123-.009-.248-.012-.374v-.019c0-.12.003-.232.006-.346z"
                />
                <path
                    fill="#ffdf02"
                    d="M176.504 153.457a16.902 16.902 0 01-7.657 13.265c-4.244 2.449-7.695.48-7.711-4.394a16.887 16.887 0 017.66-13.275c4.238-2.449 7.692-.481 7.708 4.404zm-3.38 5.438c-.248-1.804-1.121-2.936-2.316-3.112a4.362 4.362 0 00.32-1.537c0-1.475-1.043-2.062-2.322-1.323a5.077 5.077 0 00-2.31 3.998 1.956 1.956 0 00.332 1.16 12.138 12.138 0 00-2.294 5.777l8.59-4.963z"
                />
                <path
                    fill="#efb185"
                    d="M257.143 65.066s-.868-7.868-1.704-9.353c-.84-1.487-4.228-7.88-9.993-8.87-3.125-.546-1.364 2.742 1.521 6.43 1.317 1.668 2.647 2.624 2.23 6.187a24.265 24.265 0 00.976 8.368c.595 1.83 6.97-2.762 6.97-2.762z"
                />
                <path
                    fill="#e6a376"
                    d="M249.994 67.495c-.597-1.833-.898-5.695-2.417-7.802-1.804-2.542.707-4.752-.61-6.42-2.241-2.868-3.778-5.595-2.898-6.332 1.544 2.31 5.284 1.582 7.252 8.52a45.707 45.707 0 01.789 11.919c-1.462.503-1.883.827-2.116.115z"
                />
                <path
                    fill="#efb185"
                    d="M252.393 67.177s-5.46-7.049-6.793-9.432c-1.342-2.376-1.295-4.595-.648-4.405.638.194 4.995 7.011 6.91 4.853 1.021-1.144-.029 7.798.531 8.984z"
                />
                <path
                    fill="#8525d9"
                    d="M306.363 100.355s-.67 9.868-13.14 6.436c-12.47-3.431-34.917-12.574-37.794-18.578-2.87-6.007-5.796-22.172-5.796-22.172s6.07 2.014 8.336-2.93l9.87 20.027s39.146 10.332 38.524 17.217z"
                />
                <path
                    fill="#b64fff"
                    d="M306.363 100.355c.622-6.885-38.523-17.217-38.523-17.217l-9.87-20.027a5.352 5.352 0 01-3.59 3.087c1.037 5.126 3.071 14.309 5.089 18.516 2.873 6.01 25.324 15.153 37.793 18.583 3.625.996 6.224.85 8.136.178a8.757 8.757 0 00.965-3.12z"
                />
                <path
                    d="M317.578 260.279c19.471 11.242 19.568 29.471.224 40.71-19.326 11.237-50.789 11.237-70.262-.004-19.459-11.235-19.559-29.464-.22-40.69 19.335-11.248 50.8-11.248 70.258-.016z"
                    opacity="0.1"
                />
                <path
                    fill="#111114"
                    d="M286.046 261.197s-4.686.712-3.548 3.405c1.138 2.702 6.525 6.812 7.23 8.52.713 1.703 5.11 7.801 6.528 7.235 1.428-.572 5.112.28 4.688-6.671-.425-6.95-8.658-12.772-14.898-12.49zM277.11 286.736s2.27 6.67-3.404 8.234c-5.674 1.559-3.98-1.985-16.318 1.13-12.354 3.123-13.762-3.254-13.48-4.681.28-1.416 8.507-3.974 11.207-4.683 2.69-.704 7.802-1.985 7.802-1.985h14.636z"
                />
                <path
                    fill="#16162f"
                    d="M300.428 169.64s.075 40.287.075 44.821c0 4.537 5.068 40.279 2.025 55.89 0 0-8.786 8.808-16.554 0 0 0-2.483-44.741-4.73-54.846-2.248-10.098-1.494-40.99-1.494-40.99z"
                />
                <path
                    fill="#16162f"
                    d="M285.022 175.366s-2.003 26.01-4.071 51.803c0 0-1.295 51.194-2.505 58.564 0 0-16.513 4.096-18.157-3.684 0 0 .418-45.052 0-54.468-.418-9.417-1.389-35.68 2.33-50.833 3.722-15.151 22.403-1.382 22.403-1.382z"
                />
                <path
                    fill="#2a3554"
                    d="M278.446 285.733c1.21-7.37 2.505-58.564 2.505-58.564 1.393-17.364 2.748-34.814 3.486-44.375L274.24 185.3s-7.347 19.296-6.227 48.234c.867 22.4 1.232 44.434 1.351 53.274a41.466 41.466 0 009.082-1.075zM302.528 270.35c3.043-15.61-2.025-51.352-2.025-55.889 0-4.323-.063-41.053-.075-44.528l-8.861 6.815s-2.82 28.803 0 45.206c2.561 14.925.911 43.98 2.16 52.311 4.903 0 8.8-3.915 8.8-3.915z"
                />
                <path
                    fill="#b64fff"
                    d="M302.895 96.485s8.516 4.253 3.685 18.727c-4.816 14.472-8.223 23.834-7.944 29.225.292 5.39 2.267 23.547 3.41 27.24 0 0 1.415 11.922-25.82 19.017 0 0-22.419 2.266-18.734-12.488 3.69-14.755 5.114-38.587 4.545-44.267-.569-5.674-3.976-17.023 10.21-24.685 14.199-7.662 21.573-13.333 30.648-12.769z"
                />
                <path
                    fill="#8525d9"
                    d="M262.037 133.94c.569 5.68-.855 29.511-4.545 44.267-2.55 10.225 7.43 12.272 13.802 12.564 2.04-6.586-1.408-18.334 3.323-32.712 5.84-17.768 5.02-29.506 1.89-38.97-2.028-6.142-5.719-6.304-8.337-7.165-9.38 7.436-6.64 16.97-6.133 22.015z"
                />
                <path
                    fill="#efb185"
                    d="M292.824 89.337s-.908 7.562 1.688 12.297c2.36 4.294-15.46 8.206-15.878 4.23a17.084 17.084 0 00-.933-14.652c-2.248-4.04 15.123-1.875 15.123-1.875z"
                />
                <path
                    fill="#dd9569"
                    d="M294.42 101.892c-1.93-3.512-1.93-8.597-1.79-10.97l-13.008 6.456c0 .012.006.022.006.03.471.12 9.257 2.343 11.153 8.661 2.678-1.097 4.498-2.612 3.64-4.177z"
                />
                <path
                    fill="#efb185"
                    d="M274.057 69.25s-2.766 6.872-2.21 12.775c.582 6.367-.36 7.651.038 10.479.167 1.204.258 3.036 1.44 4.173 1.974 1.897 6.017 2.595 11.505.59 6.636-2.428 13.624-11.548 10.782-19.751-2.845-8.201-11.57-14.948-21.555-8.266z"
                />
                <path
                    fill="#e6a376"
                    d="M295.314 86.385c-2.66-7.379-9.261-16.232-9.201-16.7.04-.286-2.15-1.666-4.646-3.13a14.944 14.944 0 00-7.41 2.695 36.975 36.975 0 00-1.376 4.423c1.58 1.769 4.806 3.78 5.29 5.284a19.253 19.253 0 01-.556 11.254c-1.056 2.362 3.203 5.83 2.307 7.924a.517.517 0 00-.028.282 18.814 18.814 0 005.136-1.15c4.24-1.552 8.61-5.85 10.484-10.882z"
                />
                <path
                    fill="#131c24"
                    d="M273.105 67.179c-2.172 1.23-1.97 5.142 3.829 7.981 3.483 1.706 3.174 7.318 3.005 8.363-.164 1.044-1.191 5.778-.764 6.383.817 1.167 3.54-2.475 4.841-2.224 3.29.641 2.005 3.71-.99 6.944-3.188 3.415 5.206 4.825 9.084 1.997 2.06-1.502 2.814-2.398 5.52-7.786 3.945-7.847 4.14-17.276-5.14-22.307-9.273-5.027-13.99-2.411-19.385.649z"
                />
                <path
                    fill="#1d2833"
                    d="M292.11 96.623c2.06-1.502 2.814-2.398 5.52-7.786 3.945-7.847 5.297-17.25-3.982-22.282-9.274-5.025-13.071-3.728-18.452-.654-.516.294-3.26 1.539-3.053 2.903 2.946.475 10.99 2.056 13.064 5.517 2.556 4.26 5.391 2.887 5.174 8.177-.204 5.107 1.113 11.783-7.453 14.663 3.185 2.287 7.677.56 9.182-.538z"
                />
                <path
                    fill="#8525d9"
                    d="M279.637 103.51l-5.806 4.886s18.062 5.18 23.353-3.681c.748-1.252-.154-5.454-3.307-6.24 0 0-.613 7.21-14.24 5.036z"
                />
                <path
                    fill="#f1b287"
                    d="M222.81 146.72s-6.79-.521-7.9-1.889c-1.11-1.366-3.344-.245-1.876 1.242a10.197 10.197 0 003.731 2.173s-7.997.44-8.704-1.9c-.707-2.34-.836 6.244 2.747 7.848 3.59 1.617 7.221 4.042 15.174-1.89 0 0-.249-3.866-3.172-5.584z"
                />
                <path
                    fill="#8525d9"
                    d="M271.144 111.786s8.845 3.564 1.977 13.985c-6.862 10.414-19.342 27.486-25.716 28.34-6.36.84-24.23 1.072-24.23 1.072s2.986-5.48-.877-9.03l22.595-5.07s20.115-31.913 26.25-29.297z"
                />
                <path
                    fill="#b64fff"
                    d="M271.144 111.786c-6.136-2.616-26.251 29.296-26.251 29.296l-22.595 5.07a5.815 5.815 0 011.644 2.531c7.591-.924 21.636-2.778 24.525-4.235 3.536-1.772 21.055-25.322 25.17-30.911a8.335 8.335 0 00-2.493-1.751z"
                />
            </g>
        </svg>
    );
}

export default MobileSvg;